var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
define(["require", "exports", "./context", "./priceFormula", "./assetPicker", "./productImages", "./priceFormula", "./number", "./analytics", "./canvas", "./settings", "./design", "./object", "./images", "./util", "./fallbackMatchingFabric"], function (require, exports, context_1, formula, assetPicker_1, productImages_1, priceFormula_1, number_1, analytics_1, canvas_1, settings_1, design_1, object_1, images_1, util_1, fallbackMatchingFabric_1) {
    "use strict";
    exports.__esModule = true;
    var partsImageBase = "" + requestSpecificCdnEndpoint + partsPathBase + "/";
    var hdPartsImageBase = requestSpecificCdnEndpoint + "parts/";
    var useHdPartsForFringes = true;
    var nonHdPartsIdentifier = "/" + partsPathBase + "/";
    var canvasPerspectiveTransform = null;
    function setPerspectiveTransform(f) {
        canvasPerspectiveTransform = f;
    }
    exports.setPerspectiveTransform = setPerspectiveTransform;
    var noWall = false;
    function setNoWall(flag) {
        noWall = flag;
    }
    exports.setNoWall = setNoWall;
    var WindowType;
    (function (WindowType) {
        WindowType[WindowType["SingleWindow"] = 0] = "SingleWindow";
        WindowType[WindowType["BayWindow"] = 1] = "BayWindow";
        WindowType[WindowType["TwoWindowsSideBySide"] = 2] = "TwoWindowsSideBySide";
        WindowType[WindowType["ArchWindow"] = 3] = "ArchWindow";
    })(WindowType = exports.WindowType || (exports.WindowType = {}));
    ;
    var ProductType;
    (function (ProductType) {
        ProductType[ProductType["FullSet"] = 0] = "FullSet";
        ProductType[ProductType["ValanceOnly"] = 1] = "ValanceOnly";
        ProductType[ProductType["DrapeOnly"] = 2] = "DrapeOnly";
        ProductType[ProductType["WindowOnly"] = 3] = "WindowOnly";
        ProductType[ProductType["WindowAndTwoRods"] = 4] = "WindowAndTwoRods";
        ProductType[ProductType["WindowAndOneRodAndDrapes"] = 5] = "WindowAndOneRodAndDrapes";
        ProductType[ProductType["WindowAndTwoRodsAndDrapes"] = 6] = "WindowAndTwoRodsAndDrapes";
    })(ProductType = exports.ProductType || (exports.ProductType = {}));
    ;
    exports.ProductTypes = {
        FullSet: ProductType.FullSet,
        ValanceOnly: ProductType.ValanceOnly,
        DrapeOnly: ProductType.DrapeOnly,
        WindowOnly: ProductType.WindowOnly,
        WindowAndTwoRods: ProductType.WindowAndTwoRods,
        WindowAndOneRodAndDrapes: ProductType.WindowAndOneRodAndDrapes,
        WindowAndTwoRodsAndDrapes: ProductType.WindowAndTwoRodsAndDrapes
    };
    var MeasurementSegment;
    (function (MeasurementSegment) {
        MeasurementSegment[MeasurementSegment["_undefined"] = 0] = "_undefined";
        MeasurementSegment[MeasurementSegment["windowHeight"] = 1] = "windowHeight";
        MeasurementSegment[MeasurementSegment["windowWidth"] = 2] = "windowWidth";
        MeasurementSegment[MeasurementSegment["topMargin"] = 3] = "topMargin";
        MeasurementSegment[MeasurementSegment["bottomMargin"] = 4] = "bottomMargin";
        MeasurementSegment[MeasurementSegment["leftMargin"] = 5] = "leftMargin";
        MeasurementSegment[MeasurementSegment["rightMargin"] = 6] = "rightMargin";
    })(MeasurementSegment = exports.MeasurementSegment || (exports.MeasurementSegment = {}));
    var WallColor;
    (function (WallColor) {
        WallColor[WallColor["CloudWhite"] = 0] = "CloudWhite";
        WallColor[WallColor["ClassicGray"] = 1] = "ClassicGray";
        WallColor[WallColor["BlueArrow"] = 2] = "BlueArrow";
        WallColor[WallColor["SeaSalt"] = 3] = "SeaSalt";
        WallColor[WallColor["ClayBeige"] = 4] = "ClayBeige";
        WallColor[WallColor["SavoryBeige"] = 5] = "SavoryBeige";
        WallColor[WallColor["Yellow"] = 6] = "Yellow";
        WallColor[WallColor["OrangeBlossom"] = 7] = "OrangeBlossom";
        WallColor[WallColor["RubyRed"] = 8] = "RubyRed";
    })(WallColor = exports.WallColor || (exports.WallColor = {}));
    exports.wallColor_to_hex = [
        "#f3f3e4",
        "#e1dfd4",
        "#a5aeab",
        "#ced4ca",
        "#d8cbb8",
        "#e3dcca",
        "#ebd67b",
        "#e07a4c",
        "#a12926"
    ];
    exports.SKETCH_FABRIC_CODE = 'SKETCH00';
    var swagType_to_dimension = {
        A: [38, 20],
        B: [33, 20],
        C: [50, 20],
        D: [34, 17],
        E: [29, 17],
        F: [45, 17],
        A1: [33, 20],
        B1: [30, 20],
        C1: [27, 20],
        D1: [45, 20]
    };
    var valance_to_swagLayout = {
        1: {
            35: ['B', 1, 0],
            40: ['A', 1, 0],
            45: ['A', 1, 0],
            50: ['C', 1, 0],
            55: ['C', 1, 0],
            60: ['B', 2, 6],
            65: ['B', 2, 7],
            70: ['A', 2, 6],
            75: ['A', 2, 7],
            80: ['B', 3, 9.5],
            85: ['B', 3, 7],
            90: ['B', 3, 6.5],
            95: ['A', 3, 9.5],
            100: ['A', 3, 7],
            105: ['B', 4, 9],
            110: ['B', 4, 7.3],
            115: ['B', 4, 5.7],
            120: ['B', 4, 5.3],
            125: ['A', 4, 9],
            130: ['A', 4, 7.3],
            135: ['B', 5, 7.5],
            140: ['B', 5, 6.3],
            145: ['B', 5, 5],
            150: ['B', 5, 5.3],
            155: ['A', 5, 8.8],
            160: ['A', 5, 7.5],
            165: ['B', 6, 6.6],
            170: ['B', 6, 5.6],
            175: ['B', 6, 5.4],
            180: ['A', 6, 9.6],
            185: ['A', 6, 8.6],
            190: ['A', 6, 7.6],
            195: ['B', 7, 6.0],
            200: ['B', 7, 5.8]
        },
        2: {
            35: ['A1', 1, 0.5],
            40: ['A1', 1, 0.5],
            45: ['D1', 1, 0.5],
            50: ['D1', 1, 0.5],
            55: ['D1', 1, 0.5],
            60: ['B1', 2, 0.5],
            65: ['A1', 2, 1],
            70: ['A1', 2, 0.5],
            75: ['A1', 2, 0.5],
            80: ['C1', 3, 0.5],
            85: ['C1', 3, 0.5],
            90: ['B1', 3, 0.5],
            95: ['B1', 3, 0.5],
            100: ['A1', 3, 0.5],
            105: ['C1', 4, 1],
            110: ['C1', 4, 0.5],
            115: ['C1', 4, 0.5],
            120: ['B1', 4, 0.5],
            125: ['B1', 4, 0.5],
            130: ['A1', 4, 0.7],
            135: ['A1', 4, 0.5],
            140: ['A1', 4, 0.5],
            145: ['C1', 5, 0.5],
            150: ['B1', 5, 0.5],
            155: ['B1', 5, 0.5],
            160: ['C1', 5, 0.5],
            165: ['C1', 6, 0.5],
            170: ['C1', 6, 0.5],
            175: ['B1', 6, 1],
            180: ['B1', 6, 0.5],
            185: ['B1', 6, 0.5],
            190: ['B1', 6, 0.5],
            195: ['C1', 7, 0.5],
            200: ['C1', 7, 0.5]
        }
    };
    var fringeName = {
        1: "Tassel-Red.png",
        2: "Tassel-Gold.png",
        3: "Tassel-Brown.png",
        4: "Tassel-SilverGray.png",
        5: "Tassel-SteelBlue.png",
        6: "Tassel-Beige.png",
        7: "Ball-Gold.png",
        8: "Ball-Brown.png",
        9: "Ball-RedGold.png",
        10: "Ball-PinkGreen.png",
        11: "Ball-Yellow.png",
        12: "Ball-Green.png",
        13: "Tassel-Red.png",
        14: "Tassel-Gold.png",
        15: "Tassel-Green.png",
        16: "Tassel-Pink.png",
        17: "Tassel-Black.png",
        18: "Tassel-White.png",
        19: "Tassel-Purple.png",
        20: "Tassel-OffWhite.png",
        21: "Tassel-Bronze.png"
    };
    var StyleEnum;
    (function (StyleEnum) {
        StyleEnum[StyleEnum["ClassicOverlapping"] = 1] = "ClassicOverlapping";
        StyleEnum[StyleEnum["AustrianSwag"] = 2] = "AustrianSwag";
        StyleEnum[StyleEnum["AustrianDiamond"] = 3] = "AustrianDiamond";
        StyleEnum[StyleEnum["AustrianDiamondSwag"] = 3] = "AustrianDiamondSwag";
        StyleEnum[StyleEnum["ParisSalon"] = 4] = "ParisSalon";
        StyleEnum[StyleEnum["FlipPoleSwag"] = 5] = "FlipPoleSwag";
        StyleEnum[StyleEnum["WideOverlapping"] = 6] = "WideOverlapping";
        StyleEnum[StyleEnum["HalfOverlapping"] = 7] = "HalfOverlapping";
        StyleEnum[StyleEnum["WideOverlappingTailless"] = 8] = "WideOverlappingTailless";
        StyleEnum[StyleEnum["SwagOverHoldback"] = 9] = "SwagOverHoldback";
        StyleEnum[StyleEnum["SwagsOverHoldback"] = 9] = "SwagsOverHoldback";
        StyleEnum[StyleEnum["PanelWithSwag"] = 10] = "PanelWithSwag";
        StyleEnum[StyleEnum["ParisSalonCascade"] = 11] = "ParisSalonCascade";
        StyleEnum[StyleEnum["AustrianPelmet"] = 12] = "AustrianPelmet";
        StyleEnum[StyleEnum["PalacePelmet"] = 13] = "PalacePelmet";
        StyleEnum[StyleEnum["PalacePelmetSalon"] = 14] = "PalacePelmetSalon";
        StyleEnum[StyleEnum["KyotoSalon"] = 15] = "KyotoSalon";
    })(StyleEnum = exports.StyleEnum || (exports.StyleEnum = {}));
    function defaultWithMatchingFabric(styleIndex) {
        return [
            StyleEnum.ParisSalon,
            StyleEnum.AustrianPelmet,
            StyleEnum.PalacePelmet,
            StyleEnum.PalacePelmetSalon,
            StyleEnum.KyotoSalon
        ].indexOf(styleIndex) >= 0;
    }
    exports.defaultWithMatchingFabric = defaultWithMatchingFabric;
    function getStyleIndexFromStyleName(styleName) {
        var styleNumber = -1;
        switch (styleName) {
            case "Classic Overlapping Style":
                styleNumber = StyleEnum.ClassicOverlapping;
                break;
            case "Austrian Swag Style":
                styleNumber = StyleEnum.AustrianSwag;
                break;
            case "Austrian Diamond Style":
            case "Austrian Diamond Swag Style":
                styleNumber = StyleEnum.AustrianDiamond;
                break;
            case "Paris Salon Style":
                styleNumber = StyleEnum.ParisSalon;
                break;
            case "Flip Pole Swag Style":
                styleNumber = StyleEnum.FlipPoleSwag;
                break;
            case "Wide Overlapping Style":
                styleNumber = StyleEnum.WideOverlapping;
                break;
            case "Half Overlapping Style":
                styleNumber = StyleEnum.HalfOverlapping;
                break;
            case "Wide Overlapping Tailless Style":
                styleNumber = StyleEnum.WideOverlappingTailless;
                break;
            case "Swags Over Holdback Style":
            case "Swag Over Holdback Style":
                styleNumber = StyleEnum.SwagsOverHoldback;
                break;
            case "Panel With Swag Style":
                styleNumber = StyleEnum.PanelWithSwag;
                break;
            case "Paris Salon Cascade Style":
                styleNumber = StyleEnum.ParisSalonCascade;
                break;
            case "Austrian Pelmet Style":
                styleNumber = StyleEnum.AustrianPelmet;
                break;
            case "Palace Pelmet Swag Style":
                styleNumber = StyleEnum.PalacePelmet;
                break;
            case "Palace Pelmet Salon Style":
                styleNumber = StyleEnum.PalacePelmetSalon;
                break;
            case "Kyoto Salon Style":
                styleNumber = StyleEnum.KyotoSalon;
                break;
            default: break;
        }
        return styleNumber;
    }
    exports.getStyleIndexFromStyleName = getStyleIndexFromStyleName;
    exports.styleNamesMap = {
        style_1: "Classic Overlapping Style",
        style_2: "Austrian Swag Style",
        style_3: "Austrian Diamond Swag Style",
        style_4: "Paris Salon Style",
        style_5: "Flip Pole Swag Style",
        style_6: "Wide Overlapping Style",
        style_7: "Half Overlapping Style",
        style_8: "Wide Overlapping Tailless Style",
        style_9: "Swag Over Holdback Style",
        style_10: "Panel With Swag Style",
        style_11: "Paris Salon Cascade Style",
        style_12: "Austrian Pelmet Style",
        style_13: "Palace Pelmet Swag Style",
        style_14: "Palace Pelmet Salon Style",
        style_15: "Kyoto Salon Style"
    };
    exports.parts = {
        1: ["Swags", "swags"],
        2: ["Fans", "fans"],
        3: ["Odd Swags", "oddSwags"],
        4: ["Even Swags", "evenSwags"],
        5: ["Rod Pocket", "rodPockets"],
        6: ["Side Tails", "sideTails"],
        7: ["Middle Tails", "midTails"],
        8: ["Drape Panels", "drapes"]
    };
    exports.styleToMatchingFabricParts = {
        1: {
            "valance": false, "swags": false, "rodPocket": false, "sideTails": true, "drapes": false
        },
        2: {
            "valance": false, "swags": false, "rodPocket": false, "sideTails": true, "drapes": false
        },
        3: {
            "valance": false, "swags": true, "rodPocket": true, "drapes": false
        },
        4: {
            "valance": false, "swags": true, "fans": false, "rodPocket": false, "sideTails": false,
            "drapes": false
        },
        5: {
            "valance": false, "swags": false, "sideTails": true, "drapes": false
        },
        6: {
            "valance": false, "swags": false, "rodPocket": false, "sideTails": true, "drapes": false
        },
        7: {
            "valance": false, "swags": false, "rodPocket": false, "sideTails": true, "drapes": false
        },
        8: {
            "valance": false, "swags": true, "rodPocket": true, "drapes": false
        },
        9: {
            "valance": false, "swags": false, "midTails": true, "sideTails": true, "drapes": false
        },
        10: {
            "valance": false, "swags": true, "drapes": false
        },
        11: {
            "valance": false, "midTails": true, "sideTails": true, "fans": false, "rodPocket": false, "drapes": false
        },
        12: {
            "swags": false, "pelmet": true, "rodPocket": false, "sideTails": false, "drapes": false
        },
        13: {
            "swags": true, "pelmet": false, "rodPocket": false, "drapes": false
        },
        14: {
            "fans": true, "pelmet": false, "rodPocket": false, "drapes": false
        },
        15: {
            "valance": false, "swags": true, "pelmet": false, "fans": false, "rodPocket": false,
            "drapes": false
        }
    };
    var styleToSwagLayerStyle = {
        1: [["ClassicSwag", "ClassicSwagFringe"]],
        2: [["AustrianSwag", "AustrianSwagFringe"]],
        3: [["PleatedSwags/pleatedSwag", "PleatedSwagFringe"]],
        4: [["ClassicSwag", "ClassicSwagFringe"], ["FanSwag", null]],
        5: [["PoleSwag", "ClassicSwagFringe"]],
        6: [["ClassicSwag", "ClassicSwagFringe"]],
        7: [["ClassicSwag", "ClassicSwagFringe"]],
        8: [["ClassicSwag", "ClassicSwagFringe"]],
        9: [["HoldbackSwag", "ClassicSwagFringe"]],
        10: [["PoleSwag", "ClassicSwagFringe"]],
        11: [["FanSwag", null]],
        12: [["AustrianPelmet/AustrianPelmet", "AustrianSwagFringe"]],
        13: [["PalacePelmet/PalacePelmet", "PalacePelmetFringe"], ["PoleSwag", null]],
        14: [["PalacePelmet/PalacePelmet", "PalacePelmetFringe"], ["FanSwag", null]],
        15: [["ClassicSwag", null], ["KyotoPelmet/KyotoPelmet", null], ["KyotoFan/KyotoFan", "PalacePelmetFringe"]]
    };
    function styleNeedsMatchingFabric(style) {
        return [
            StyleEnum.ParisSalon,
            StyleEnum.KyotoSalon,
            StyleEnum.AustrianPelmet,
            StyleEnum.PalacePelmet,
            StyleEnum.PalacePelmetSalon
        ].indexOf(style) >= 0;
    }
    exports.styleNeedsMatchingFabric = styleNeedsMatchingFabric;
    function roundToMultipleOf(val, base) {
        return base * Math.round(val / base);
    }
    var KyotoPelmet_TopWidth = 7;
    var KyotoPelmet_Width = 13;
    var KyotoPelmet_Height = 19;
    var KyotoPelmet_TopSpacing = 12;
    var KyotoFan_Width = 18;
    var KyotoFan_Height = 14;
    var KyotoFan_TopDrop = 10;
    function configDrape(simple_spec) {
        var productType = simple_spec.productType, style = simple_spec.style;
        if (style === StyleEnum.PanelWithSwag) {
            return DrapeConfig.leftWithRightHint;
        }
        if (productType === ProductType.DrapeOnly) {
            return DrapeConfig.leftWithRightHint;
        }
        return DrapeConfig.leftAndRight;
    }
    function complete_custom_parameters(simple_spec) {
        var swagCount, swagOverlap, swagDimension;
        if (simple_spec.style == 3) {
            swagCount = Math.round(simple_spec.width / 20);
            swagDimension = [simple_spec.width / swagCount, 20];
            swagOverlap = 0;
        }
        else if (simple_spec.style == 4 || simple_spec.style == 11) {
            var swagCount = Math.round(simple_spec.width / 25);
            if (swagCount < 2) {
                swagCount = 2;
            }
            var swagWidth = simple_spec.width / swagCount;
            swagDimension = [swagWidth, 13];
            swagOverlap = 0;
        }
        else if (simple_spec.style == 15) {
            var swagCount = Math.round((simple_spec.width - KyotoPelmet_TopWidth) / (KyotoPelmet_TopWidth + KyotoPelmet_TopSpacing)) + 1;
            swagDimension = [KyotoPelmet_Width, KyotoPelmet_Height];
            swagOverlap = -(simple_spec.width + KyotoPelmet_Width - KyotoPelmet_TopWidth - swagCount * KyotoPelmet_Width) / (swagCount - 1);
        }
        else if (simple_spec.style == 12) {
            var swagCount = Math.round(simple_spec.width / 20);
            var swagWidth = simple_spec.width / swagCount;
            swagDimension = [swagWidth, 25];
            swagOverlap = 0;
        }
        else if (simple_spec.style == 13 || simple_spec.style == 14) {
            var swagCount = Math.round(simple_spec.width / 12);
            var swagWidth = simple_spec.width / swagCount;
            swagDimension = [swagWidth, 38.5];
            swagOverlap = 0;
        }
        else if (simple_spec.style == 5) {
            var swagCount = Math.round(simple_spec.width / 30);
            swagWidth = simple_spec.width / (0.8 * swagCount + 0.2);
            swagOverlap = swagWidth * 0.2;
            swagDimension = [swagWidth, 18];
        }
        else if (simple_spec.style == 6 || simple_spec.style == 8) {
            var swagCount = Math.round(simple_spec.width / 24.0) - 1;
            if (swagCount < 1)
                swagCount = 1;
            swagWidth = Math.min(48, simple_spec.width);
            swagOverlap = (swagCount * swagWidth - simple_spec.width) / (swagCount - 1);
            if (swagOverlap < 0)
                swagOverlap = 0;
            swagDimension = [swagWidth, 16];
        }
        else if (simple_spec.style == 7) {
            var swagCount = Math.round(simple_spec.width / 17) - 1;
            swagWidth = 29;
            swagOverlap = (swagCount * swagWidth - simple_spec.width) / (swagCount - 1);
            if (swagOverlap < 0)
                swagOverlap = 0;
            swagDimension = [swagWidth, 18];
        }
        else if (simple_spec.style == 9) {
            var swagCount = Math.round(simple_spec.width / 30);
            swagWidth = simple_spec.width / (0.9 * swagCount + 0.1);
            swagOverlap = swagWidth * 0.1;
            swagDimension = [swagWidth, 20];
        }
        else if (simple_spec.style == 10) {
            var swagCount = 2;
            simple_spec.width = 90;
            swagWidth = 35;
            swagOverlap = 2 * swagWidth - simple_spec.width;
            swagDimension = [swagWidth, 25];
        }
        else if (simple_spec.style === 1 || simple_spec.style === 2) {
            var specMap = valance_to_swagLayout[simple_spec.style];
            var swagLayout = specMap[roundToMultipleOf(simple_spec.width || 100, 5)];
            if (swagLayout) {
                swagCount = swagLayout[1];
                swagOverlap = swagLayout[2];
                var swagType = swagLayout[0];
                swagDimension = swagType_to_dimension[swagType];
            }
        }
        swagCount = swagCount || 0;
        swagOverlap = swagOverlap || 0;
        swagDimension = swagDimension || [0];
        var swagMargin = (simple_spec.width - (swagCount * swagDimension[0] - (swagCount - 1) * swagOverlap)) / 2.0;
        var swagLayer0 = {
            swagPartName: (simple_spec.style == 11 || simple_spec.style == 4) ? "fans" : (simple_spec.style == 13 || simple_spec.style == 14 || simple_spec.style == 15) ? "pelmet" : "swags",
            swagOrder: (simple_spec.style == 4) ? 4 : ((swagCount > 3 || simple_spec.style == 6 || simple_spec.style == 8) ? 1 : 3),
            swagCount: swagCount,
            swagWidth: swagDimension[0],
            swagHeight: swagDimension[1],
            swagOverlap: swagOverlap,
            swagMargin: swagMargin,
            swagDrop: (simple_spec.style == 12) ? -3 : 0,
            hasMidTail: (simple_spec.style == 9 || simple_spec.style == 11),
            midTailHeight: (simple_spec.style == 11) ? 17 : 0
        };
        if (simple_spec.style == 13 || simple_spec.style == 14) {
            var swagDrops = new Array(swagCount);
            var currentDrop = 0, longSwag = true;
            for (var leftIndex = 0, rightIndex = swagCount - 1; leftIndex <= rightIndex; leftIndex++, rightIndex--) {
                swagDrops[leftIndex] = swagDrops[rightIndex] = currentDrop;
                longSwag = !longSwag;
                currentDrop = longSwag ? -8 : -16;
            }
            swagLayer0.swagDrops = swagDrops;
        }
        var swagLayers = [swagLayer0];
        if (simple_spec.style == 4) {
            var swagLayerUnder = {
                swagPartName: "swags",
                swagOrder: 3,
                swagCount: swagCount - 1,
                swagWidth: swagDimension[0],
                swagHeight: swagDimension[1] + 2,
                swagOverlap: swagOverlap,
                swagMargin: swagMargin + swagDimension[0] / 2,
                swagDrop: 0,
                hasMidTail: false,
                midTailHeight: 0
            };
            swagLayers.splice(0, 0, swagLayerUnder);
        }
        else if (simple_spec.style == 15) {
            var horizontal_interval = (swagDimension[0] - swagOverlap);
            var swagLayerOver = {
                swagPartName: "fans",
                swagOrder: 1,
                swagCount: swagCount - 1,
                swagWidth: KyotoFan_Width,
                swagHeight: KyotoFan_Height,
                swagOverlap: -(horizontal_interval - KyotoFan_Width),
                swagMargin: 0,
                swagDrop: KyotoFan_TopDrop,
                hasMidTail: false,
                midTailHeight: 0,
                fringeDrop: -21
            };
            swagLayerOver.swagMargin = (simple_spec.width - (swagLayerOver.swagCount * swagLayerOver.swagWidth - (swagLayerOver.swagCount - 1) * swagLayerOver.swagOverlap)) / 2.0;
            swagLayers.push(swagLayerOver);
            var swagLayerUnder = {
                swagPartName: "swags",
                swagOrder: 1,
                swagCount: swagCount - 1,
                swagWidth: 22,
                swagHeight: 15,
                swagOverlap: 22 - horizontal_interval,
                swagMargin: 0,
                swagDrop: 0,
                hasMidTail: false,
                midTailHeight: 0
            };
            swagLayerUnder.swagMargin = (simple_spec.width - (swagLayerUnder.swagCount * swagLayerUnder.swagWidth - (swagLayerUnder.swagCount - 1) * swagLayerUnder.swagOverlap)) / 2.0;
            swagLayers.splice(0, 0, swagLayerUnder);
        }
        else if (simple_spec.style == 13) {
            var swagLayerOver = {
                swagPartName: "swags",
                swagOrder: 1,
                swagCount: Math.floor(swagCount / 3),
                swagWidth: swagWidth * 3,
                swagHeight: 19,
                swagOverlap: 0,
                swagMargin: (swagCount % 3) * swagWidth / 2,
                swagDrop: 0,
                hasMidTail: false,
                midTailHeight: 0
            };
            swagLayers.push(swagLayerOver);
        }
        else if (simple_spec.style == 14) {
            var fanCount = Math.floor((swagCount - 1) / 2);
            var swagLayerOver = {
                swagPartName: "fans",
                swagOrder: 1,
                swagCount: fanCount,
                swagWidth: swagWidth * 2,
                swagHeight: 13,
                swagOverlap: 0,
                swagMargin: (simple_spec.width - fanCount * swagWidth * 2) / 2,
                swagDrop: 0,
                hasMidTail: false,
                midTailHeight: 0
            };
            swagLayers.push(swagLayerOver);
        }
        for (var i in swagLayers) {
            swagLayers[i].swagStyle = styleToSwagLayerStyle[simple_spec.style][i][0];
            swagLayers[i].fringeStyle = styleToSwagLayerStyle[simple_spec.style][i][1];
        }
        var tailZOrder = (simple_spec.style == 3 || simple_spec.style == 8 || simple_spec.style == 10 || simple_spec.style == 13 || simple_spec.style == 14 || simple_spec.style == 15) ? 0 : ((simple_spec.style == 2 || simple_spec.style == 12) ? 2 : (simple_spec.style == 5) ? 1 : 1);
        var tailStyle = (simple_spec.style == 11) ? 4 : (simple_spec.style == 9) ? 3 : (simple_spec.style == 2 || simple_spec.style == 5 || simple_spec.style == 12 || simple_spec.style == 4) ? 2 : 1;
        var full_spec = {
            style: simple_spec.style,
            productType: (simple_spec.style == 10) ? ProductType.FullSet : simple_spec.productType,
            width: simple_spec.width,
            height: simple_spec.height,
            fringeStyle: simple_spec.fringeStyle || 0,
            fabricMain: simple_spec.fabricMain,
            fabricMatching: defaultWithMatchingFabric(simple_spec.style) ? getFabricNameFromCodeName(fallbackMatchingFabric_1["default"].fabricCodeName) : simple_spec.fabricMain,
            tailStyle: tailStyle,
            tailZOrder: tailZOrder,
            swagLayers: swagLayers,
            tailHeight: (simple_spec.style == 11) ? 38 : 50,
            tailWidth: (simple_spec.style == 11) ? 11 : (simple_spec.style == 5) ? swagOverlap : 0,
            rodPocketHeight: (simple_spec.style == 5 || simple_spec.style == 9 || simple_spec.style == 10) ? 0 : 3,
            pelmetHeight: (simple_spec.style == 12) ? 9 : 0,
            swagTop: (simple_spec.style == 5 || simple_spec.style == 9 || simple_spec.style == 10) ? 0 : 3,
            drapes: configDrape(simple_spec),
            drapeWidth: (simple_spec.width < 80) ? 80 : 100,
            drapeHeight: simple_spec.height,
            drapeWithSwag: (simple_spec.style == StyleEnum.PanelWithSwag),
            windowWidth: simple_spec.windowWidth ? simple_spec.windowWidth : ((simple_spec.width || 100) - 10),
            windowTop2Ceiling: 20,
            windowHeight: simple_spec.height - 24 - 11,
            windowBottom2Floor: 24,
            showValanceRod: (simple_spec.style == 10 && simple_spec.productType != ProductType.WindowOnly) ||
                (simple_spec.style != 9) && (simple_spec.productType != ProductType.WindowOnly) && (simple_spec.productType != ProductType.DrapeOnly) && (simple_spec.productType != ProductType.WindowAndOneRodAndDrapes),
            showDrapeRod: (simple_spec.style != 10) && (simple_spec.productType != ProductType.WindowOnly) && (simple_spec.productType != ProductType.ValanceOnly)
                && (simple_spec.productType != ProductType.FullSet),
            showHoldbacks: simple_spec.style == 9 && simple_spec.productType != ProductType.DrapeOnly,
            showValance: !(simple_spec.style == 10) && (simple_spec.productType == ProductType.FullSet || simple_spec.productType == ProductType.ValanceOnly),
            showDrapes: (simple_spec.style == 10) || (simple_spec.productType == ProductType.FullSet || simple_spec.productType == ProductType.DrapeOnly),
            rightDrapeFaded: (simple_spec.style == 10) || simple_spec.productType == ProductType.DrapeOnly,
            windowOnly: simple_spec.productType == ProductType.WindowOnly,
            skipClipping: (simple_spec.style == 15),
            curtainAlpha: 1,
            setback: 12,
            withSheers: simple_spec.withSheers,
            tailOffset: ((tailStyle == 1 || tailStyle == 4) ? 0 : (tailStyle == 2) ? 0.4 : 2.5)
        };
        full_spec.setback = (full_spec.width - full_spec.windowWidth) / 2;
        return full_spec;
    }
    exports.complete_custom_parameters = complete_custom_parameters;
    var DrapeConfig;
    (function (DrapeConfig) {
        DrapeConfig[DrapeConfig["leftAndRight"] = 1] = "leftAndRight";
        DrapeConfig[DrapeConfig["leftOnly"] = 2] = "leftOnly";
        DrapeConfig[DrapeConfig["rightOnly"] = 3] = "rightOnly";
        DrapeConfig[DrapeConfig["leftWithRightHint"] = 4] = "leftWithRightHint";
        DrapeConfig[DrapeConfig["leftOnly_Wide"] = 6] = "leftOnly_Wide";
    })(DrapeConfig = exports.DrapeConfig || (exports.DrapeConfig = {}));
    function imageCollector(expectedCount, completeFn) {
        var receivedCount = 0;
        return function (evt) {
            return function () {
                console.info('imageCollector called on ' + evt + "; receivedCount = " + (receivedCount + 1));
                if (++receivedCount == expectedCount) {
                    console.info("recivedCount=" + receivedCount + " -> calling completedFn");
                    completeFn();
                }
            };
        };
    }
    ;
    function getImageUrls(fullSpec, baseUrl, fabric2_parts) {
        var fabricSuffix = fullSpec.fabricMain + '.png';
        var fabricMatchingSuffix = fullSpec.fabricMatching + '.png';
        var fringeBaseUrl = useHdPartsForFringes ? hdPartsImageBase : baseUrl;
        var images = {};
        images["rod"] = baseUrl + 'RodPocket/Rod.png';
        images["windowFrame"] = baseUrl + 'WindowFrame-1.png';
        images["rodPocket"] = baseUrl + 'RodPocket/RodPocket-' + (fabric2_parts.fabric2_for_rodPocket ? fabricMatchingSuffix : fabricSuffix);
        images["holdback"] = baseUrl + 'RosetteHoldback.png';
        if (fullSpec.productType == ProductType.WindowOnly || fullSpec.productType == ProductType.WindowAndTwoRods) {
            return images;
        }
        images["leftDrape"] = baseUrl + 'PanelRodPocket/Panel-RodPocket-Tied-' + (fabric2_parts.fabric2_for_drapes ? fabricMatchingSuffix : fabricSuffix);
        if (fullSpec.withSheers) {
            images["leftSheer"] = baseUrl + "SheerPanel.png";
        }
        if (fullSpec.productType == ProductType.DrapeOnly || fullSpec.productType == ProductType.WindowAndOneRodAndDrapes || fullSpec.productType == ProductType.WindowAndTwoRodsAndDrapes) {
            return images;
        }
        for (var i in fullSpec.swagLayers) {
            var swagLayer = fullSpec.swagLayers[i];
            var swagStyle = swagLayer.swagStyle;
            images["swag" + i] = baseUrl + ((swagStyle.indexOf("/") != -1) ? swagStyle : (swagStyle + "s/" + swagStyle)) + "-" + (fabric2_parts["fabric2_for_" + swagLayer.swagPartName] ? fabricMatchingSuffix : fabricSuffix);
            if (fullSpec.fringeStyle != 0 && swagLayer.fringeStyle != null) {
                images["fringe" + i] = fringeBaseUrl + "Fringes/" + swagLayer.fringeStyle + "-" + fringeName[fullSpec.fringeStyle];
            }
            if (swagLayer.hasMidTail) {
                if (fullSpec.style == 11) {
                    images["midTail"] = baseUrl + 'MidCascadeTail/MidCascadeTail-' + (fabric2_parts.fabric2_for_midTails ? fabricMatchingSuffix : fabricSuffix);
                }
                else {
                    images["midTail"] = baseUrl + 'MidFishTail/MidFishTail-' + (fabric2_parts.fabric2_for_midTails ? fabricMatchingSuffix : fabricSuffix);
                    if (fullSpec.fringeStyle != 0) {
                        images["midTailFringe"] = fringeBaseUrl + 'Fringes/MidFishTailFringe-' + fringeName[fullSpec.fringeStyle];
                    }
                }
            }
        }
        if (fullSpec.pelmetHeight > 0) {
            images["pelmet"] = baseUrl + 'Pelmet/Pelmet-' + (fabric2_parts.fabric2_for_pelmet ? fabricMatchingSuffix : fabricSuffix);
        }
        if (fullSpec.tailZOrder != 0) {
            switch (fullSpec.tailStyle) {
                case 1:
                    images["leftTail"] = baseUrl + 'WideTailsLeft/WideTail-Left-' + (fabric2_parts.fabric2_for_sideTails ? fabricMatchingSuffix : fabricSuffix);
                    if (fullSpec.fringeStyle != 0) {
                        images["leftTailFringe"] = fringeBaseUrl + 'Fringes/WideTailFringe-' + fringeName[fullSpec.fringeStyle];
                    }
                    fullSpec.tailOffset = 0;
                    break;
                case 2:
                    images["leftTail"] = baseUrl + 'NarrowerTailsLeft/NarrowTail-Left-' + (fabric2_parts.fabric2_for_sideTails ? fabricMatchingSuffix : fabricSuffix);
                    if (fullSpec.fringeStyle != 0) {
                        images["leftTailFringe"] = fringeBaseUrl + 'Fringes/NarrowerTailFringe-' + fringeName[fullSpec.fringeStyle];
                    }
                    fullSpec.tailOffset = 0.4;
                    break;
                case 3:
                    images["leftTail"] = baseUrl + 'FishTailLeft/FishTail-Left-' + (fabric2_parts.fabric2_for_sideTails ? fabricMatchingSuffix : fabricSuffix);
                    if (fullSpec.fringeStyle != 0) {
                        images["leftTailFringe"] = fringeBaseUrl + 'Fringes/NarrowTailFringe-' + fringeName[fullSpec.fringeStyle];
                    }
                    fullSpec.tailOffset = 2.5;
                    break;
                case 4:
                    images["leftTail"] = baseUrl + 'CascadeTail/CascadeTail-' + (fabric2_parts.fabric2_for_sideTails ? fabricMatchingSuffix : fabricSuffix);
                    fullSpec.tailOffset = 0;
                    break;
            }
        }
        return images;
    }
    function loadImagesThenRender(fullSpec, baseUrl, renderFn) {
        loadImagesThenRenderPlus(fullSpec, baseUrl, {}, renderFn);
    }
    exports.loadImagesThenRender = loadImagesThenRender;
    function loadImagesThenRenderPlus(fullSpec, baseUrl, additionalImages, renderFn) {
        analytics_1["default"]('renderCustom', 'loadImagesThenRender', 'started');
        var fabric2_parts = fullSpec;
        if ((fullSpec.style == StyleEnum.ParisSalon) && (fabric2_parts.fabric2_for_swags === undefined)) {
            fabric2_parts.fabric2_for_swags = 1;
        }
        if ((fullSpec.style == StyleEnum.AustrianPelmet) && (fabric2_parts.fabric2_for_swags === undefined)) {
            fabric2_parts.fabric2_for_swags = 0;
            fabric2_parts.fabric2_for_pelmet = 1;
            fabric2_parts.fabric2_for_sideTails = 0;
            fabric2_parts.fabric2_for_rodPocket = 0;
        }
        if ((fullSpec.style == StyleEnum.PalacePelmet || fullSpec.style == StyleEnum.KyotoSalon) && (fabric2_parts.fabric2_for_swags === undefined)) {
            fabric2_parts.fabric2_for_swags = 1;
        }
        if ((fullSpec.style == StyleEnum.PalacePelmetSalon) && (fabric2_parts.fabric2_for_fans === undefined)) {
            fabric2_parts.fabric2_for_fans = 1;
        }
        var images = {
            leftTail: new Image(),
            leftTailFringe: new Image(),
            midTail: new Image(),
            midTailFringe: new Image(),
            windowFrame: new Image(),
            rodPocket: new Image(),
            leftDrape: new Image(),
            rod: new Image(),
            holdback: new Image(),
            pelmet: new Image()
        };
        var imageToUrls = getImageUrls(fullSpec, baseUrl, fabric2_parts);
        for (var imageId in additionalImages) {
            imageToUrls["img_" + imageId] = (additionalImages[imageId].startsWith("http") ? "" : requestSpecificCdnEndpoint) + additionalImages[imageId];
        }
        for (var imageName in imageToUrls) {
            if (!images[imageName]) {
                images[imageName] = new Image();
            }
        }
        var imagesRequested = 0;
        for (var imageName in imageToUrls) {
            imagesRequested++;
        }
        var ic = imageCollector(imagesRequested, function () {
            analytics_1["default"]('renderCustom', 'loadImagesThenRender', 'completed');
            renderFn(images);
            $('body').trigger('customize:renderCustomDone');
        });
        $.each(imageToUrls, function (imageName, imageUrl) {
            images[imageName].crossOrigin = "Anonymous";
            images[imageName].onload = ic(imageName + ".onload");
            images[imageName].onerror = ic(imageName + ".onerror");
            images[imageName].src = imageUrl;
        });
    }
    CanvasRenderingContext2D.prototype.roundRect = function (x, y, w, h, r) {
        if (w < 2 * r)
            r = w / 2;
        if (h < 2 * r)
            r = h / 2;
        this.beginPath();
        this.moveTo(x + r, y);
        this.arcTo(x + w, y, x + w, y + h, r);
        this.arcTo(x + w, y + h, x, y + h, r);
        this.arcTo(x, y + h, x, y, r);
        this.arcTo(x, y, x + w, y, r);
        this.closePath();
        return this;
    };
    function drawQuadrilateral(ctx, x0, y0, x1, y1, x2, y2, x3, y3, fillStyle) {
        ctx.fillStyle = fillStyle;
        ctx.beginPath();
        ctx.moveTo(x0, y0);
        ctx.lineTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.lineTo(x3, y3);
        ctx.closePath();
        ctx.fill();
    }
    function drawWall(ctx, fullSpec) {
        var wallTop = -(fullSpec.windowHeight + fullSpec.windowTop2Ceiling + fullSpec.windowBottom2Floor - fullSpec.height);
        var viewPortTop = wallTop - 15;
        var wallBottom = fullSpec.height;
        var viewPortBottom = wallBottom + 18;
        var wallLeft = fullSpec.windowLeftMargin ? -(fullSpec.windowLeftMargin - fullSpec.setback) : -20;
        var viewPortLeft = wallLeft - 20;
        var wallRight = fullSpec.windowRightMargin ? (fullSpec.setback + fullSpec.windowWidth + fullSpec.windowRightMargin) : fullSpec.width + 20;
        var viewPortRight = wallRight + 20;
        var wallColorHex = fullSpec.wallColorHex || exports.wallColor_to_hex[fullSpec.wallColor] || "#a9a9a9";
        drawWalls(ctx, {
            showSideWall: true,
            wallTop: wallTop, wallBottom: wallBottom, wallLeft: wallLeft, wallRight: wallRight, viewPortBottom: viewPortBottom, viewPortLeft: viewPortLeft, viewPortRight: viewPortRight, viewPortTop: viewPortTop, wallColorHex: wallColorHex
        });
    }
    function drawWalls(ctx, walls) {
        var wallColorHex = walls.wallColorHex, wallTop = walls.wallTop, wallLeft = walls.wallLeft, wallRight = walls.wallRight, wallBottom = walls.wallBottom, viewPortTop = walls.viewPortTop, viewPortRight = walls.viewPortRight, viewPortLeft = walls.viewPortLeft, viewPortBottom = walls.viewPortBottom;
        drawQuadrilateral(ctx, wallLeft, wallTop, wallRight, wallTop, viewPortRight, viewPortTop, viewPortLeft, viewPortTop, lighten(wallColorHex, 0.15));
        drawQuadrilateral(ctx, wallLeft, wallTop, wallRight, wallTop, wallRight, wallBottom, wallLeft, wallBottom, wallColorHex);
        if (walls.showSideWall) {
            drawQuadrilateral(ctx, viewPortLeft, viewPortTop, wallLeft, wallTop, wallLeft, wallBottom, viewPortLeft, viewPortBottom, lighten(wallColorHex, 0.05));
            drawQuadrilateral(ctx, wallRight, wallTop, viewPortRight, viewPortTop, viewPortRight, viewPortBottom, wallRight, wallBottom, lighten(wallColorHex, -0.05));
        }
        drawQuadrilateral(ctx, wallLeft, wallBottom, wallRight, wallBottom, viewPortRight, viewPortBottom, viewPortLeft, viewPortBottom, lighten(wallColorHex, -0.15));
    }
    ;
    function computeCanvasFit(canvas, curtainBounds) {
        var fitHeight = curtainBounds.y1 - curtainBounds.y0;
        var fitWidth = curtainBounds.x1 - curtainBounds.x0;
        if (canvas.hasAttribute("containingWidth") && canvas.hasAttribute("containingHeight")) {
            var containingWidth = parseFloat(canvas.getAttribute("containingWidth"));
            var containingHeight = parseFloat(canvas.getAttribute("containingHeight"));
            var scale = Math.min(containingWidth / fitWidth, containingHeight / fitHeight);
            var canvasWidth = NaN, canvasHeight = NaN;
            switch (curtainBounds.expansionMode) {
                case "all":
                    var xCenter = (curtainBounds.x1 + curtainBounds.x0) / 2;
                    var yCenter = (curtainBounds.y1 + curtainBounds.y0) / 2;
                    fitWidth = containingWidth / scale;
                    fitHeight = containingHeight / scale;
                    curtainBounds.x0 = xCenter - fitWidth / 2;
                    curtainBounds.x1 = xCenter + fitWidth / 2;
                    curtainBounds.y0 = yCenter - fitHeight / 2;
                    curtainBounds.y1 = yCenter + fitHeight / 2;
                    canvasHeight = containingHeight;
                    canvasWidth = containingWidth;
                    break;
                case "down":
                    fitHeight = containingHeight / scale;
                    if (curtainBounds.hasOwnProperty("maxHeight")) {
                        fitHeight = Math.min(fitHeight, curtainBounds.maxHeight);
                    }
                    curtainBounds.y1 = curtainBounds.y0 + fitHeight;
                    canvasWidth = containingWidth;
                    canvasHeight = fitHeight * scale;
                    break;
                case "right":
                    fitWidth = containingWidth / scale;
                    if (curtainBounds.hasOwnProperty("maxWidth")) {
                        fitWidth = Math.min(fitWidth, curtainBounds.maxWidth);
                    }
                    curtainBounds.x1 = curtainBounds.x0 + fitWidth;
                    canvasWidth = fitWidth * scale;
                    canvasHeight = containingHeight;
                    break;
                default:
                    canvasHeight = scale * fitHeight;
                    canvasWidth = scale * fitWidth;
            }
            if (canvas.hasAttribute("minHeight")) {
                var minHeight = parseFloat(canvas.getAttribute("minHeight"));
                if (canvasHeight < minHeight) {
                    scale = minHeight / fitHeight;
                    canvasWidth = scale * fitWidth;
                    canvasHeight = minHeight;
                }
            }
            var $canvas = $(canvas);
            if (canvasHeight !== parseInt($canvas.attr('height'))) {
                $canvas.attr("height", canvasHeight);
            }
            if (canvasWidth !== parseInt($canvas.attr('width'))) {
                $canvas.attr("width", canvasWidth);
            }
        }
        else {
            scale = Math.min(canvas.width / fitWidth, canvas.height / fitHeight);
            canvasWidth = canvas.width;
            canvasHeight = canvas.height;
        }
        return {
            scale: scale,
            fitWidth: fitWidth,
            fitHeight: fitHeight,
            canvasWidth: canvasWidth,
            canvasHeight: canvasHeight
        };
    }
    exports.computeCanvasFit = computeCanvasFit;
    function drawPlayButton(canvas) {
        var ctx = canvas.getContext("2d");
        var centerX = canvas.width / 2;
        var centerY = canvas.height / 2;
        var radius = Math.min(canvas.width, canvas.height) * 0.3;
        ctx.beginPath();
        ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI, false);
        ctx.fillStyle = 'gray';
        ctx.globalAlpha = 0.9;
        ctx.fill();
        ctx.beginPath();
        ctx.moveTo(centerX - radius / 4, centerY - radius * .433);
        ctx.lineTo(centerX - radius / 4, centerY + radius * .433);
        ctx.lineTo(centerX + radius / 2, centerY);
        ctx.fillStyle = 'white';
        ctx.fill();
    }
    function clearCurtainSetCanvas(canvas, curtainBounds, fit, showWall, noClear) {
        var scaleX, scaleY, canvasBeginX, canvasBeginY, fitWidth, fitHeight;
        if (curtainBounds.canvasX0 != null) {
            canvasBeginX = curtainBounds.canvasX0;
            canvasBeginY = curtainBounds.canvasY0;
            scaleX = (curtainBounds.canvasX1 - curtainBounds.canvasX0) / (curtainBounds.x1 - curtainBounds.x0);
            scaleY = (curtainBounds.canvasY1 - curtainBounds.canvasY0) / (curtainBounds.y1 - curtainBounds.y0);
            fitWidth = (curtainBounds.x1 - curtainBounds.x0);
            fitHeight = (curtainBounds.y1 - curtainBounds.y0);
        }
        else {
            var canvasWidth = fit.canvasWidth, canvasHeight = fit.canvasHeight, scale = fit.scale;
            fitWidth = fit.fitWidth;
            fitHeight = fit.fitHeight;
            if (!isNaN(canvasWidth)) {
                $(canvas).attr('width', canvasWidth);
            }
            if (!isNaN(canvasHeight)) {
                $(canvas).attr('height', canvasHeight);
            }
            canvasBeginX = (canvas.width - fitWidth * scale) / 2.0;
            canvasBeginY = (canvas.height - fitHeight * scale) / 2.0;
            scaleX = scaleY = scale;
        }
        var xOffset = canvasBeginX - curtainBounds.x0 * scaleX;
        var yOffset = canvasBeginY - curtainBounds.y0 * scaleY;
        var ctx = canvas.getContext("2d");
        ctx.save();
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.rect(0, 0, canvas.width, canvas.height);
        if (showWall) {
            ctx.fillStyle = "White";
            ctx.fill();
        }
        else {
            if (!noClear) {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
            }
        }
        ctx.translate(xOffset, yOffset);
        ctx.scale(scaleX, scaleY);
        ctx.beginPath();
        if (curtainBounds.roundedCorner) {
            ctx.roundRect(curtainBounds.x0, curtainBounds.y0, fitWidth, fitHeight, 30 / scaleX);
        }
        else {
            ctx.rect(curtainBounds.x0, curtainBounds.y0, fitWidth, fitHeight);
        }
        ctx.save();
        ctx.clip();
        return ctx;
    }
    function computeRoomFit(canvas, fullSpec) {
        var bounds = {
            x0: 0,
            y0: 0,
            x1: fullSpec.width,
            y1: fullSpec.height,
            expansionMode: 'all'
        };
        var fit = computeCanvasFit(canvas, bounds);
        var wallHeight = fullSpec.windowHeight + fullSpec.windowTop2Ceiling + fullSpec.windowBottom2Floor;
        var wallWidth = fullSpec.windowWidth + fullSpec.windowLeftMargin + fullSpec.windowRightMargin;
        console.log("wallHeight = " + wallHeight + ", wallWidth = " + wallWidth + ", fit = " + JSON.stringify(fit, null, 2));
        var room = {
            wallTop: (fit.fitHeight - wallHeight) * 0.4,
            wallBottom: fit.fitHeight - (fit.fitHeight - wallHeight) * 0.6,
            wallLeft: (fit.fitWidth - wallWidth) / 2,
            wallRight: fit.fitWidth - (fit.fitWidth - wallWidth) / 2
        };
        var result = __assign({}, fit, room, object_1.pick(fullSpec, 'windowBottom2Floor', 'windowRightMargin', 'windowTop2Ceiling', 'windowRightMargin'));
        return result;
    }
    exports.computeRoomFit = computeRoomFit;
    function drawRoom(canvas, fullSpec) {
        var fit = computeRoomFit(canvas, fullSpec);
        var bounds = {
            x0: 0,
            y0: 0,
            x1: fullSpec.width,
            y1: fullSpec.height,
            expansionMode: 'all'
        };
        var pending = $.Deferred();
        loadImagesThenRender(fullSpec, partsImageBase, function (images) {
            var ctx = clearCurtainSetCanvas(canvas, bounds, fit, true, false);
            var walls = __assign({ showSideWall: true, wallColorHex: fullSpec.wallColorHex || exports.wallColor_to_hex[fullSpec.wallColor], viewPortTop: 0, viewPortBottom: fit.fitHeight, viewPortLeft: 0, viewPortRight: fit.fitWidth }, fit);
            drawWalls(ctx, walls);
            ctx.restore();
            ctx.restore();
            pending.resolve();
        });
        return __assign({}, fit, { pending: pending });
    }
    exports.drawRoom = drawRoom;
    exports.idealRoomSpec = {
        windowTop2Ceiling: 12,
        windowBottom2Floor: 24,
        windowLeftMargin: 12,
        windowRightMargin: 12,
        setBack: 5
    };
    function computeRoomSpecFrom(curtain) {
        var windowBottom2Floor = exports.idealRoomSpec.windowBottom2Floor, windowTop2Ceiling = exports.idealRoomSpec.windowTop2Ceiling, windowLeftMargin = exports.idealRoomSpec.windowLeftMargin, windowRightMargin = exports.idealRoomSpec.windowRightMargin, setBack = exports.idealRoomSpec.setBack;
        var wallWidth = curtain.width + windowLeftMargin + windowRightMargin - 2 * setBack;
        var wallHeight = curtain.height + windowTop2Ceiling + windowBottom2Floor;
        return __assign({ wallTop: 4, wallBottom: 4 + wallHeight, wallLeft: 0, wallRight: wallWidth, maxWidth: wallWidth, maxHeight: wallHeight + 12 }, object_1.pick(exports.idealRoomSpec, 'windowBottom2Floor', 'windowTop2Ceiling', 'windowLeftMargin', 'windowRightMargin', 'setBack'));
    }
    exports.computeRoomSpecFrom = computeRoomSpecFrom;
    function computeSimpleSpecFrom(roomAndWindow, current) {
        var windowWidth = roomAndWindow.windowWidth, windowHeight = roomAndWindow.windowHeight, wallLeft = roomAndWindow.wallLeft, wallRight = roomAndWindow.wallRight, wallTop = roomAndWindow.wallTop, wallBottom = roomAndWindow.wallBottom, windowBottom2Floor = roomAndWindow.windowBottom2Floor, setBack = roomAndWindow.setBack;
        return __assign({}, current, { width: Math.min(windowWidth + 2 * setBack, wallRight - wallLeft), height: Math.min(windowHeight + windowBottom2Floor + 1, wallBottom - wallTop) });
    }
    exports.computeSimpleSpecFrom = computeSimpleSpecFrom;
    function computeRoomCanvasSpecFrom(roomSpec) {
        var wallLeft = roomSpec.wallLeft, wallRight = roomSpec.wallRight, wallBottom = roomSpec.wallBottom, wallTop = roomSpec.wallTop;
        var wallWidth = wallRight - wallLeft;
        var wallHeight = wallBottom - wallTop;
        var fitWidth = wallWidth + 6;
        var fitHeight = wallHeight + 10;
        var canvasSize = design_1.fitBoundingBox({ Width: fitWidth, Height: fitHeight }, images_1.DesignSize);
        return {
            fitHeight: wallHeight + 6,
            fitWidth: wallWidth + 6,
            canvasWidth: canvasSize.Width,
            canvasHeight: canvasSize.Height,
            scale: (wallWidth + 6) / canvasSize.Width
        };
    }
    exports.computeRoomCanvasSpecFrom = computeRoomCanvasSpecFrom;
    function drawWindowFrame(canvas, fullSpec) {
        var result = $.Deferred();
        loadImagesThenRender(fullSpec, partsImageBase, function (images) {
            var bounds = {
                x0: 0,
                y0: 0,
                x1: fullSpec.width,
                y1: fullSpec.height
            };
            var fit = computeCanvasFit(canvas, bounds);
            var windowCount = Math.round(fullSpec.windowWidth / 30);
            var ctx = clearCurtainSetCanvas(canvas, bounds, fit, false, false);
            var wallHeight = fullSpec.windowHeight + fullSpec.windowTop2Ceiling + fullSpec.windowBottom2Floor;
            var wallWidth = fullSpec.windowWidth + fullSpec.windowLeftMargin + fullSpec.windowRightMargin;
            var walls = {
                showSideWall: true,
                wallColorHex: fullSpec.wallColorHex || exports.wallColor_to_hex[fullSpec.wallColor],
                viewPortTop: 0,
                viewPortBottom: fit.fitHeight,
                viewPortLeft: 0,
                viewPortRight: fit.fitWidth,
                wallTop: (fullSpec.height - wallHeight) * 0.4,
                wallBottom: fit.fitHeight - (fit.fitHeight - wallHeight) * 0.6,
                wallLeft: (fit.fitWidth - wallWidth) / 2,
                wallRight: fit.fitWidth - (fit.fitWidth - wallWidth) / 2
            };
            drawWindowFrameToCtx(ctx, fullSpec, images, windowCount, walls.wallLeft + fullSpec.windowLeftMargin, walls.wallTop + fullSpec.windowTop2Ceiling);
            result.resolve(__assign({}, fullSpec, { maxHeight: fullSpec.height, maxWidth: fullSpec.width, wallTop: walls.wallTop, wallBottom: walls.wallBottom, wallLeft: walls.wallLeft, wallRight: walls.wallRight }));
            ctx.restore();
            ctx.restore();
        });
        return result;
    }
    exports.drawWindowFrame = drawWindowFrame;
    function drawCurtainSet(canvas, fullSpec, curtainBounds, images, showWall, showWindow, noClear, test) {
        if (showWall === void 0) { showWall = true; }
        if (showWindow === void 0) { showWindow = true; }
        if (noClear === void 0) { noClear = false; }
        if (test === void 0) { test = false; }
        var fit = null;
        if (curtainBounds.canvasX0 == null) {
            fit = computeCanvasFit(canvas, curtainBounds);
        }
        var ctx = clearCurtainSetCanvas(canvas, curtainBounds, fit, showWall, noClear);
        drawCurtainSetUsingRenderingContext(ctx, fullSpec, images, showWall, showWindow, noClear);
        ctx.restore();
        return ctx;
    }
    exports.drawCurtainSet = drawCurtainSet;
    function drawCurtainSetUsingRenderingContext(ctx, fullSpec, images, showWall, showWindow, noClear) {
        if (showWall === void 0) { showWall = true; }
        if (showWindow === void 0) { showWindow = true; }
        if (noClear === void 0) { noClear = false; }
        var windowCount = Math.round(fullSpec.windowWidth / 30);
        if (showWall) {
            drawWall(ctx, fullSpec);
        }
        if (showWindow) {
            drawWindowFrameToCtx(ctx, fullSpec, images, windowCount);
        }
        ctx.globalAlpha = fullSpec.curtainAlpha;
        console.info("drawcurtainSet", fullSpec);
        drawValance(ctx, fullSpec, images, windowCount);
        if (fullSpec.productType === ProductType.WindowOnly) {
            var $f = $('#panel0 .worksheet:visible input[name="windowSizeEdit"]:checked');
            var inputId = $f.length ? $f.val() : $(':focus').data('sync');
            if (inputId && MeasurementSegment[inputId]) {
                drawWindowMeasureMents(ctx, fullSpec, MeasurementSegment[inputId]);
            }
        }
    }
    function lighten(color, luminosity) {
        color = new String(color).replace(/[^0-9a-f]/gi, '');
        if (color.length < 6) {
            color = color[0] + color[0] + color[1] + color[1] + color[2] + color[2];
        }
        luminosity = luminosity || 0;
        var newColor = "#", c, i, black = 0, white = 255;
        for (i = 0; i < 3; i++) {
            c = parseInt(color.substr(i * 2, 2), 16);
            c = Math.round(Math.min(Math.max(black, c + (luminosity * white)), white)).toString(16);
            newColor += ("00" + c).substr(c.length);
        }
        return newColor;
    }
    function drawImageSafe(ctx, image, left, top, width, height) {
        if (image.width != 0) {
            ctx.drawImage(image, left, top, width, height);
        }
    }
    function drawImageFlippedSafe(ctx, image, left, top, width, height) {
        if (image.width != 0) {
            ctx.save();
            ctx.scale(-1, 1);
            ctx.drawImage(image, -(left + width), top, width, height);
            ctx.restore();
        }
    }
    function drawWindowFrameToCtx(ctx, fullSpec, images, windowCount, windowLeftMost, windowTopPosition) {
        var windowWidth = fullSpec.windowWidth;
        var windowHeight = fullSpec.windowHeight;
        var windowPaneWidth = windowWidth / windowCount;
        var windowTop = windowTopPosition || (fullSpec.height - fullSpec.windowHeight - fullSpec.windowBottom2Floor);
        var leftMost = windowLeftMost || (fullSpec.width - windowWidth) / 2;
        for (var i = 0; i < windowCount; i++) {
            drawImageSafe(ctx, images.windowFrame, leftMost + windowPaneWidth * i, windowTop, windowPaneWidth, windowHeight);
        }
    }
    function drawWindowMeasureMents(ctx, spec, seg) {
        ctx.lineWidth = 0.4;
        ctx.beginPath();
        ctx.strokeStyle = '#ff0000';
        var windowWidth = spec.windowWidth, windowHeight = spec.windowHeight, windowTop2Ceiling = spec.windowTop2Ceiling, windowBottom2Floor = spec.windowBottom2Floor, height = spec.height, width = spec.width;
        var windowLeft = spec.setback;
        var windowRight = spec.setback + windowWidth;
        var windowTop = height - (windowHeight + windowBottom2Floor);
        var tickWidth = 4;
        var setBack = 12;
        switch (seg) {
            case MeasurementSegment.topMargin:
                drawTickedSegment(ctx, { begin: { x: windowRight + setBack, y: windowTop - windowTop2Ceiling }, end: { x: windowRight + setBack, y: windowTop }, tickWidth: tickWidth });
                break;
            case MeasurementSegment.windowHeight:
                drawTickedSegment(ctx, { begin: { x: windowRight + setBack, y: windowTop }, end: { x: windowRight + setBack, y: windowTop + windowHeight }, tickWidth: tickWidth });
                break;
            case MeasurementSegment.bottomMargin:
                drawTickedSegment(ctx, { begin: { x: windowRight + setBack, y: windowTop + windowHeight }, end: { x: windowRight + setBack, y: windowTop + windowHeight + windowBottom2Floor - 0.5 }, tickWidth: tickWidth });
                break;
            case MeasurementSegment.leftMargin:
                drawTickedSegment(ctx, { begin: { x: windowLeft, y: windowTop + windowHeight + setBack }, end: { x: windowLeft - (spec.windowLeftMargin ? spec.windowLeftMargin : 11), y: windowTop + windowHeight + setBack }, tickWidth: tickWidth });
                break;
            case MeasurementSegment.windowWidth:
                drawTickedSegment(ctx, { begin: { x: windowLeft, y: windowTop + windowHeight + setBack }, end: { x: windowRight, y: windowTop + windowHeight + setBack }, tickWidth: tickWidth });
                break;
            case MeasurementSegment.rightMargin:
                drawTickedSegment(ctx, { begin: { x: windowRight, y: windowTop + windowHeight + setBack }, end: { x: windowRight + (spec.windowRightMargin ? spec.windowRightMargin : 11), y: windowTop + windowHeight + setBack }, tickWidth: tickWidth });
                break;
            default:
        }
        ctx.stroke();
    }
    function drawSegment(ctx, seg) {
        ctx.moveTo(seg.begin.x, seg.begin.y);
        ctx.lineTo(seg.end.x, seg.end.y);
    }
    function drawTickAt(ctx, at, orientation, width) {
        var tickStart = { x: 0, y: 0 };
        var tickEnd = { x: 0, y: 0 };
        if (orientation === 'horizontal') {
            tickStart.x = at.x - width / 2;
            tickStart.y = at.y;
            tickEnd.x = at.x + width / 2;
            tickEnd.y = at.y;
        }
        else {
            tickStart.y = at.y - width / 2;
            tickStart.x = at.x;
            tickEnd.y = at.y + width / 2;
            tickEnd.x = at.x;
        }
        drawSegment(ctx, { begin: tickStart, end: tickEnd });
    }
    function drawTickedSegment(ctx, seg) {
        drawTickAt(ctx, seg.begin, isVertical(seg) ? 'horizontal' : 'vertical', seg.tickWidth);
        drawSegment(ctx, seg);
        drawTickAt(ctx, seg.end, isVertical(seg) ? 'horizontal' : 'vertical', seg.tickWidth);
    }
    function isVertical(seg) {
        return seg.begin.x == seg.end.x && seg.begin.y != seg.end.y;
    }
    function drawRodPocket(ctx, fullSpec, images, windowCount) {
        var smallPocketWidth = fullSpec.width / windowCount;
        if (fullSpec.rodPocketHeight > 0) {
            var isOdd = true;
            for (var i = 0; i < windowCount; i++) {
                if (isOdd) {
                    drawImageSafe(ctx, images.rodPocket, smallPocketWidth * i, 0, smallPocketWidth, fullSpec.rodPocketHeight + 0.6);
                    if (fullSpec.pelmetHeight > 0) {
                        drawImageSafe(ctx, images.pelmet, smallPocketWidth * i, fullSpec.rodPocketHeight + 0.6, smallPocketWidth, fullSpec.pelmetHeight);
                    }
                }
                else {
                    drawImageFlippedSafe(ctx, images.rodPocket, smallPocketWidth * i, 0, smallPocketWidth, fullSpec.rodPocketHeight + 0.6);
                    if (fullSpec.pelmetHeight > 0) {
                        drawImageFlippedSafe(ctx, images.pelmet, smallPocketWidth * i, fullSpec.rodPocketHeight + 0.6, smallPocketWidth, fullSpec.pelmetHeight);
                    }
                }
                isOdd = !isOdd;
            }
        }
    }
    function drawLeftDrape(ctx, fullSpec, images, margin, drapeWidth) {
        if (!drapeWidth)
            drapeWidth = Math.min(fullSpec.width / 2, fullSpec.drapeWidth / 3);
        if (fullSpec.drapeWithSwag) {
            drawImageSafe(ctx, images.leftDrape, 0, -1, fullSpec.swagLayers[0].swagWidth, fullSpec.drapeHeight + 4);
        }
        else {
            drawImageSafe(ctx, images.leftDrape, 1 + margin, 4 + ((fullSpec.rodPocketHeight == 0) ? 2 : 0), drapeWidth, fullSpec.drapeHeight - 1);
        }
    }
    ;
    function drawRightDrape(ctx, fullSpec, images, margin) {
        var drapeWidth = Math.min(fullSpec.width / 2, fullSpec.drapeWidth / 3);
        if (fullSpec.drapeWithSwag) {
            drawImageFlippedSafe(ctx, images.leftDrape, fullSpec.width - fullSpec.swagLayers[0].swagWidth, -1, fullSpec.swagLayers[0].swagWidth, fullSpec.drapeHeight + 4);
        }
        else {
            drawImageFlippedSafe(ctx, images.leftDrape, fullSpec.width - drapeWidth - 1 - margin, 4 + ((fullSpec.rodPocketHeight == 0) ? 2 : 0), drapeWidth, fullSpec.drapeHeight - 1);
        }
    }
    ;
    function drawDrapes(ctx, fullSpec, images, margin) {
        if (margin === void 0) { margin = 0; }
        switch (fullSpec.drapes) {
            case DrapeConfig.leftAndRight:
                drawLeftDrape(ctx, fullSpec, images, margin);
                drawRightDrape(ctx, fullSpec, images, margin);
                break;
            case DrapeConfig.leftOnly:
                drawLeftDrape(ctx, fullSpec, images, margin);
                break;
            case DrapeConfig.leftOnly_Wide:
                drawLeftDrape(ctx, fullSpec, images, margin, fullSpec.width * .75);
                break;
            case DrapeConfig.rightOnly:
                drawRightDrape(ctx, fullSpec, images, margin);
                break;
            case DrapeConfig.leftWithRightHint:
                drawLeftDrape(ctx, fullSpec, images, margin);
                ctx.save();
                ctx.globalAlpha = 0.5;
                drawRightDrape(ctx, fullSpec, images, margin);
                ctx.restore();
                break;
        }
    }
    ;
    function drawSwagAndFringe(ctx, swagImage, fringeImage, swagLeft, swagTop, swagWidth, swagHeight, fringeDrop) {
        drawImageSafe(ctx, swagImage, swagLeft, swagTop, swagWidth, swagHeight);
        if (fringeImage) {
            var swagCenter = swagLeft + swagWidth / 2;
            if (swagImage.width != 0 && fringeImage.width != 0) {
                var fringeXFactor = (swagImage.src.indexOf(nonHdPartsIdentifier) == -1) ? 1 : fringeToSwagDpiRatio;
                var ratioX = fringeImage.width / swagImage.width / fringeXFactor;
                var ratioY = fringeImage.height / swagImage.height / fringeXFactor;
                drawImageSafe(ctx, fringeImage, swagCenter - swagWidth / 2 * ratioX, swagTop + (fringeDrop ? fringeDrop : 0), swagWidth * ratioX, swagHeight * ratioY);
            }
        }
    }
    function drawSwags(ctx, fullSpec, images) {
        for (var i = 0; i < fullSpec.swagLayers.length; i++) {
            drawSwagLayer(ctx, fullSpec, i, images);
        }
    }
    function drawSwagLayer(ctx, fullSpec, layerNumber, images) {
        var swagLayer = fullSpec.swagLayers[layerNumber];
        var fringeHeight = swagLayer.swagHeight + 4;
        var swagStep = swagLayer.swagWidth - swagLayer.swagOverlap;
        if (swagLayer.hasMidTail) {
            for (var i = 1; i < swagLayer.swagCount; i++) {
                var tailPosition = swagLayer.swagMargin + i * (swagLayer.swagWidth - swagLayer.swagOverlap) + swagLayer.swagOverlap / 2;
                drawMidTail(tailPosition, ctx, fullSpec, swagLayer, images);
            }
        }
        ctx.save();
        if (!fullSpec.skipClipping) {
            ctx.beginPath();
            ctx.rect(0, fullSpec.rodPocketHeight, fullSpec.width, fullSpec.height - fullSpec.rodPocketHeight);
            ctx.clip();
        }
        var drawSwag = function (swag, fringes, i) {
            if (fullSpec.rightDrapeFaded && fullSpec.style == 10 && i == 1) {
                ctx.save();
                ctx.globalAlpha = 0.5;
            }
            var left = swagLayer.swagMargin + i * swagStep;
            if (swagLayer.swagDrops != null) {
                drawSwagAndFringe(ctx, swag, fringes, left, fullSpec.swagTop + swagLayer.swagDrops[i], swagLayer.swagWidth, swagLayer.swagHeight, swagLayer.fringeDrop);
            }
            else {
                drawSwagAndFringe(ctx, swag, fringes, left, fullSpec.swagTop + swagLayer.swagDrop, swagLayer.swagWidth, swagLayer.swagHeight, swagLayer.fringeDrop);
            }
            if (fullSpec.rightDrapeFaded && fullSpec.style == 10 && i == 1) {
                ctx.restore();
            }
        };
        var swagImage = images["swag" + layerNumber];
        var fringeImage = images["fringe" + layerNumber];
        switch (swagLayer.swagOrder) {
            case 1:
                for (var i = 0; i < swagLayer.swagCount; i++) {
                    drawSwag(swagImage, fringeImage, i);
                }
                break;
            case 2:
                for (var i = swagLayer.swagCount - 1; i >= 0; i--) {
                    drawSwag(swagImage, fringeImage, i);
                }
                break;
            case 3:
                for (var i = 0; i < swagLayer.swagCount; i += 2) {
                    drawSwag(swagImage, fringeImage, i);
                }
                for (var i = 1; i < swagLayer.swagCount; i += 2) {
                    drawSwag(swagImage, fringeImage, i);
                }
                break;
            case 4:
                for (var i = 1; i < swagLayer.swagCount; i += 2) {
                    drawSwag(swagImage, fringeImage, i);
                }
                for (var i = 0; i < swagLayer.swagCount; i += 2) {
                    drawSwag(swagImage, fringeImage, i);
                }
                break;
        }
        ctx.restore();
    }
    ;
    function drawLeftTail(ctx, fullSpec, images) {
        if (images.leftTail.width != 0) {
            var tailWidth = (fullSpec.tailWidth != 0) ? fullSpec.tailWidth : images.leftTail.width / images.leftTail.height * fullSpec.tailHeight;
            var nudgeToTheSide = (fullSpec.style == 5) ? 1 : 0;
            drawSwagAndFringe(ctx, images.leftTail, images.leftTailFringe, -fullSpec.tailOffset - nudgeToTheSide * 1.4, fullSpec.swagTop, tailWidth + nudgeToTheSide * 1.2, fullSpec.tailHeight);
        }
    }
    function drawMidTail(centerX, ctx, fullSpec, swagLayer, images) {
        if (images.midTail.width != 0) {
            var tailHeight = (swagLayer.midTailHeight != 0) ? swagLayer.midTailHeight : (swagLayer.swagHeight * 1.25);
            var tailWidth = images.midTail.width / images.midTail.height * tailHeight;
            drawSwagAndFringe(ctx, images.midTail, images.midTailFringe, centerX - tailWidth * 0.5, fullSpec.swagTop, tailWidth, tailHeight);
        }
    }
    function drawRightTail(ctx, fullSpec, images) {
        ctx.save();
        ctx.scale(-1, 1);
        if (images.leftTail.width != 0) {
            var tailWidth = (fullSpec.tailWidth != 0) ? fullSpec.tailWidth : images.leftTail.width / images.leftTail.height * fullSpec.tailHeight;
            var nudgeToTheSide = (fullSpec.style == 5) ? 1 : 0;
            drawSwagAndFringe(ctx, images.leftTail, images.leftTailFringe, -(fullSpec.width + fullSpec.tailOffset + nudgeToTheSide * 1.4), fullSpec.swagTop, tailWidth + nudgeToTheSide * 1.2, fullSpec.tailHeight);
        }
        ctx.restore();
    }
    ;
    function drawValance(ctx, fullSpec, images, windowCount) {
        console.info("fullSpec.windowOnly = ", fullSpec.windowOnly);
        if (fullSpec.windowOnly) {
            return;
        }
        if (fullSpec.showValanceRod) {
            drawImageSafe(ctx, images.rod, -1.5, 0.2, fullSpec.width + 3, 2);
        }
        if (fullSpec.showDrapeRod) {
            drawImageSafe(ctx, images.rod, 0.5, 5.5 + ((fullSpec.rodPocketHeight == 0) ? 2 : 0), fullSpec.width - 1, 2);
        }
        if (fullSpec.showHoldbacks && !fullSpec.showValance) {
            drawHoldbacks(fullSpec, ctx, images);
        }
        if (fullSpec.withSheers) {
            var leftDrapeImage = images.leftDrape;
            images.leftDrape = images["leftSheer"];
            fullSpec.drapeWidth *= 1.5;
            fullSpec.drapeHeight -= 2;
            drawDrapes(ctx, fullSpec, images, 2);
            images.leftDrape = leftDrapeImage;
            fullSpec.drapeWidth /= 1.5;
            fullSpec.drapeHeight += 2;
        }
        if (fullSpec.showDrapes) {
            drawDrapes(ctx, fullSpec, images);
        }
        if (!fullSpec.showValance && !(fullSpec.style == 10 && fullSpec.showDrapes)) {
            return;
        }
        drawRodPocket(ctx, fullSpec, images, windowCount);
        switch (fullSpec.tailZOrder) {
            case 1:
                {
                    drawRightTail(ctx, fullSpec, images);
                    drawLeftTail(ctx, fullSpec, images);
                    drawSwags(ctx, fullSpec, images);
                }
                ;
                break;
            case 2:
                {
                    drawSwags(ctx, fullSpec, images);
                    drawLeftTail(ctx, fullSpec, images);
                    drawRightTail(ctx, fullSpec, images);
                }
                ;
                break;
            case 3:
                {
                    drawRightTail(ctx, fullSpec, images);
                    drawSwags(ctx, fullSpec, images);
                    drawLeftTail(ctx, fullSpec, images);
                }
                ;
                break;
            case 4:
                {
                    drawLeftTail(ctx, fullSpec, images);
                    drawSwags(ctx, fullSpec, images);
                    drawRightTail(ctx, fullSpec, images);
                }
                break;
            case 5:
                {
                    drawLeftTail(ctx, fullSpec, images);
                    drawSwags(ctx, fullSpec, images);
                }
                ;
                break;
            case 6:
                {
                    drawSwags(ctx, fullSpec, images);
                    drawLeftTail(ctx, fullSpec, images);
                }
                break;
            case 7:
                {
                    drawRightTail(ctx, fullSpec, images);
                    drawSwags(ctx, fullSpec, images);
                }
                ;
                break;
            case 8:
                {
                    drawSwags(ctx, fullSpec, images);
                    drawRightTail(ctx, fullSpec, images);
                }
                break;
            case 0:
                {
                    drawSwags(ctx, fullSpec, images);
                }
                break;
        }
        if (fullSpec.showHoldbacks) {
            drawHoldbacks(fullSpec, ctx, images);
        }
    }
    function drawHoldbacks(fullSpec, ctx, images) {
        var swagLayer = fullSpec.swagLayers[0];
        for (var i = 0; i < swagLayer.swagCount + 1; i++) {
            var centerX = swagLayer.swagMargin + i * (swagLayer.swagWidth - swagLayer.swagOverlap) + swagLayer.swagOverlap / 2;
            drawImageSafe(ctx, images.holdback, centerX - 3, -1, 6, 6);
        }
    }
    function getFabricNameFromCodeName(fabricCodeName) {
        if (!fabricCodeName) {
            return exports.SKETCH_FABRIC_CODE;
        }
        if (fabricCodeName.slice(0, 3) == 'CL-') {
            return fabricCodeName.slice(3);
        }
        return fabricCodeName;
    }
    exports.getFabricNameFromCodeName = getFabricNameFromCodeName;
    function getProductType() {
        var $pt = $('#ProductType');
        var customProductType = $('#custom_product_select input').data('decimal');
        return $pt.val() || customProductType || ProductType.WindowOnly;
    }
    function loadPartImage(partRelativeUrl) {
        var image = new Image();
        image.crossOrigin = "Anonymous";
        image.src = partsImageBase + partRelativeUrl;
    }
    exports.loadPartImage = loadPartImage;
    function getFullSpec(styleNumber, renderType) {
        var attributeValues = formula.getAttributesFromForm(true);
        var previewWidth = attributeValues.width;
        if (!previewWidth) {
            return null;
        }
        if (!previewWidth && context_1["default"].goodProductPicturesAvailable) {
            return null;
        }
        var productType = number_1.firstNumber(renderType, attributeValues.productType * 1, getProductType() * 1, exports.ProductTypes.WindowOnly);
        if (number_1.extractFieldAsDecimal($('#customProgress')) === 0) {
            productType = ProductType.WindowOnly;
        }
        styleNumber = styleNumber || attributeValues.styleIndex;
        var withSheers = attributeValues.sheerGrade && parseInt(attributeValues.sheerGrade) > 0;
        var simpleSpec = {
            width: previewWidth * 1,
            height: attributeValues.height * 1,
            style: styleNumber * 1,
            productType: productType,
            withSheers: withSheers,
            fabricMain: getFabricNameFromCodeName(attributeValues.fabricCodeName),
            fringeStyle: (attributeValues.fabricCodeName ? attributeValues.fringeColor : 0),
            windowWidth: attributeValues.windowWidth ? attributeValues.windowWidth * 1 : undefined
        };
        if (simpleSpec.style <= 0) {
            simpleSpec.style = 1;
        }
        var fullSpec = complete_custom_parameters(simpleSpec);
        return fullSpec;
    }
    exports.getFullSpec = getFullSpec;
    function findSharableCanvas(zoomId) {
        var $canvas = $("canvas[zoomId=\"" + zoomId + "\"]:visible");
        return $canvas.length ? $canvas[0] : null;
    }
    exports.findSharableCanvas = findSharableCanvas;
    function renderSharableCanvas(zoomId, renderHD, canvasWidth) {
        var result = $.Deferred();
        try {
            var origSpec = getFullSpec(styleIndex, NaN);
            var attributeValues = formula.getAttributesFromForm(true);
            var imageBase = renderHD ? hdPartsImageBase : partsImageBase;
            var _a = syncFullSpecWithAttributeValues(origSpec, attributeValues.productType * 1, attributeValues), fullSpec_1 = _a.fullSpec, windowLeftMargin = _a.windowLeftMargin, windowRightMargin = _a.windowRightMargin;
            var isOriginalProduct = priceFormula_1.attributesMatchProductPicture();
            if (!isOriginalProduct) {
                loadImagesThenRender(fullSpec_1, imageBase, function (images) {
                    var canvas = $('<canvas containingWidth="' + canvasWidth + '" containingHeight="' + canvasWidth + '"></canvas>')[0];
                    try {
                        renderZoomableCanvas(canvas, fullSpec_1, images, zoomId);
                        result.resolve(canvas);
                    }
                    catch (err) {
                        result.resolve(null);
                    }
                });
            }
            else {
                result.resolve(null);
            }
        }
        catch (outerError) {
            result.resolve(null);
        }
        return result.promise();
    }
    exports.renderSharableCanvas = renderSharableCanvas;
    function tryRenderCartImage() {
        var deferred = $.Deferred();
        if (!settings_1._settings.renderCartImage) {
            deferred.resolve(null);
            return deferred;
        }
        var file = null;
        var tracked = false;
        try {
            var isOriginalProduct = priceFormula_1.attributesMatchProductPicture();
            if (!isOriginalProduct) {
                analytics_1["default"]('cartImage', 'startRender');
                tracked = true;
                var canvas = null;
                if (context_1["default"].isMobile()) {
                    canvas = findSharableCanvas("0");
                }
                else {
                    var $canvas = $('.wallCanvas:visible');
                    if ($canvas.length) {
                        canvas = $canvas[0];
                    }
                    else {
                        var $zoomableCanvas = $('#zoomableCanvas:visible');
                        if ($zoomableCanvas.length) {
                            canvas = $zoomableCanvas[0];
                        }
                    }
                }
                if (canvas) {
                    file = canvas_1.canvasToJpegFile(canvas, 400, 400);
                }
                ;
            }
        }
        catch (ex) {
            analytics_1["default"]('exception', 'tryRenderCartImage', JSON.stringify(ex));
        }
        if (tracked) {
            analytics_1["default"]('cartImage', file ? 'succeeded' : 'failed');
        }
        deferred.resolve(file);
        return deferred;
    }
    exports.tryRenderCartImage = tryRenderCartImage;
    function syncFullSpecWithAttributeValues(fullSpec, productType, attributeValues) {
        fullSpec.windowType = attributeValues.windowType * 1;
        var windowLeftMargin = attributeValues.windowLeftMargin ? attributeValues.windowLeftMargin * 1 : (fullSpec.windowType == WindowType.BayWindow) ? 4 : 11;
        var windowRightMargin = attributeValues.windowRightMargin ? attributeValues.windowRightMargin * 1 : (fullSpec.windowType == WindowType.BayWindow) ? 4 : 11;
        fullSpec.windowLeftMargin = windowLeftMargin;
        fullSpec.windowRightMargin = windowRightMargin;
        if (fullSpec.setback > windowLeftMargin) {
            fullSpec.setback = windowLeftMargin - 1.5;
            fullSpec.windowWidth = fullSpec.width - fullSpec.setback * 2;
        }
        var canvasCount = productType === ProductType.WindowOnly ? 1 : 3;
        fullSpec.windowHeight = attributeValues.windowHeight ? attributeValues.windowHeight * 1 : fullSpec.windowHeight;
        fullSpec.windowTop2Ceiling = attributeValues.windowTopMargin ? attributeValues.windowTopMargin * 1 : fullSpec.windowTop2Ceiling;
        fullSpec.windowBottom2Floor = attributeValues.windowBottomMargin ? attributeValues.windowBottomMargin * 1 : fullSpec.windowBottom2Floor;
        if (fullSpec.windowType == WindowType.BayWindow) {
            fullSpec.sideCurtainWidth = attributeValues.sideWidth;
        }
        for (var _i = 0, _a = fullSpec.swagLayers; _i < _a.length; _i++) {
            var swagLayer = _a[_i];
            swagLayer.swagOrder = attributeValues.swagOrder ? attributeValues.swagOrder * 1 : swagLayer.swagOrder;
        }
        fullSpec.tailZOrder = attributeValues.tailOrder ? attributeValues.tailOrder * 1 : fullSpec.tailZOrder;
        if (attributeValues.fabric2_CodeName != null) {
            fullSpec.fabricMatching = getFabricNameFromCodeName(attributeValues.fabric2_CodeName);
        }
        if (!attributeValues.fabricCodeName) {
            fullSpec.curtainAlpha = 0.7;
        }
        var wallColorVal = attributeValues.wallColor;
        fullSpec.wallColor = wallColorVal === undefined || wallColorVal === null ? WallColor.BlueArrow : attributeValues.wallColor * 1;
        for (var key in priceFormula_1.dummyFabric2Parts) {
            if (priceFormula_1.dummyFabric2Parts.hasOwnProperty(key) && attributeValues.hasOwnProperty(key)) {
                fullSpec[key] = attributeValues[key];
            }
        }
        return { fullSpec: fullSpec, canvasCount: canvasCount, windowLeftMargin: windowLeftMargin, windowRightMargin: windowRightMargin };
    }
    function loadAndRenderFullSpec(fullSpec, drawWall, drawWindow) {
        var result = $.Deferred();
        loadImagesThenRender(fullSpec, partsImageBase, function (images) {
            var canvas = document.createElement('canvas');
            $(canvas).attr("containingHeight", 3000);
            $(canvas).attr("containingWidth", 3000);
            drawCurtainSet(canvas, fullSpec, { x0: -1.5, x1: fullSpec.width + 3, y0: -1.5, y1: fullSpec.height + 3 }, images, drawWall, drawWindow);
            result.resolve(canvas);
        });
        return result.promise();
    }
    exports.loadAndRenderFullSpec = loadAndRenderFullSpec;
    var InstallationRenderer = (function () {
        function InstallationRenderer(productPartialSequence, fullSpec, images, x0, x1, y0, y1, alternatingCanvasIds, captionTextId) {
            this.productPartialSequence = productPartialSequence;
            this.currentSequenceIndex = 0;
            this.alternatingCanvasIds = alternatingCanvasIds;
            this.captionTextId = captionTextId;
            this.fullSpec = fullSpec;
            this.images = images;
            this.x0 = x0;
            this.x1 = x1;
            this.y0 = y0;
            this.y1 = y1;
        }
        InstallationRenderer.prototype.MoveToNextState = function () {
            this.currentSequenceIndex++;
            if (this.currentSequenceIndex == this.productPartialSequence.length) {
                this.currentSequenceIndex = 0;
            }
        };
        InstallationRenderer.prototype.CurrentPrompt = function () {
            return this.productPartialSequence[this.currentSequenceIndex][1];
        };
        InstallationRenderer.prototype.RenderCurrentProductType = function (canvas) {
            var partialAttributes = this.productPartialSequence[this.currentSequenceIndex][0];
            for (var i in partialAttributes) {
                var attributeSet = partialAttributes[i];
                this.fullSpec[attributeSet[0]] = attributeSet[1];
            }
            drawCurtainSet(canvas, this.fullSpec, { x0: this.x0, x1: this.x1, y0: this.y0, y1: this.y1 }, this.images, !noWall);
        };
        InstallationRenderer.prototype.onTimerRenderer = function () {
            var _this = this;
            this.MoveToNextState();
            var activeCanvasId = this.alternatingCanvasIds[this.activeCanvasIndex];
            var inactiveCanvasId = this.alternatingCanvasIds[1 - this.activeCanvasIndex];
            this.RenderCurrentProductType($(inactiveCanvasId)[0]);
            $(this.captionTextId).text(this.CurrentPrompt());
            $(this.captionTextId).show();
            $(activeCanvasId).fadeTo(3000, 0);
            $(inactiveCanvasId).fadeTo(3000, 1, function () {
                $(_this.captionTextId).hide();
                _this.activeCanvasIndex = 1 - _this.activeCanvasIndex;
            });
        };
        InstallationRenderer.prototype.startInstallationAnimation = function () {
            var _this = this;
            this.activeCanvasIndex = 0;
            this.currentSequenceIndex = 0;
            this.RenderCurrentProductType($(this.alternatingCanvasIds[0])[0]);
            var inactiveCanvasId = this.alternatingCanvasIds[1 - this.activeCanvasIndex];
            $(inactiveCanvasId).hide();
            this.onTimerRenderer();
            this.intervalId = setInterval(function () { return _this.onTimerRenderer(); }, 4000);
        };
        InstallationRenderer.prototype.stopInstallationAnimation = function () {
            clearInterval(this.intervalId);
        };
        return InstallationRenderer;
    }());
    exports.InstallationRenderer = InstallationRenderer;
    var installationRenderer;
    function startInstructionAnimation() {
        $(".defaultCanvas").hide();
        $('.animationSprite').show();
        $("#animationCanvas0").show();
        $("#animationCanvas1").show();
        $("#animationTitle").show();
        installationRenderer.startInstallationAnimation();
    }
    exports.startInstructionAnimation = startInstructionAnimation;
    function stopInstructionAnimation() {
        $('.animationSprite').hide();
        $(".defaultCanvas").show();
        $("#animationCanvas0").hide();
        $("#animationCanvas1").hide();
        $("#animationTitle").hide();
        installationRenderer.stopInstallationAnimation();
    }
    exports.stopInstructionAnimation = stopInstructionAnimation;
    var roomSettings = {
        "scene0": { curtainPositions: [{ x0: 480, x1: 850, y0: 205, y1: 675, width: 80, height: 102 }] },
        "scene1": { curtainPositions: [{ x0: 197, x1: 660, y0: 130, y1: 556, width: 105, height: 100 }] },
        "scene2": { curtainPositions: [{ x0: 103, x1: 373, y0: 180, y1: 680, width: 50, height: 96 }, { x0: 450, x1: 720, y0: 180, y1: 680, width: 50, height: 96 }, { x0: 820, x1: 1090, y0: 180, y1: 680, width: 50, height: 96 }] },
        "scene4": { curtainPositions: [{ x0: 310, x1: 610, y0: 150, y1: 520, width: 100, height: 108 }, { x0: 0, x1: 310, y0: 150, y1: 520, width: 100, height: 108 }, { x0: 610, x1: 920, y0: 150, y1: 520, width: 100, height: 108 }] }
    };
    var sceneImages = {
        "scene0": "idea-book-background/HomeWindow-1687.jpg", "scene1": "idea-book-background/Home-Windows-3.jpg",
        "scene2": "idea-book-background/Home-Windows-Three.jpg",
        "scene4": "idea-book-background/Home-Windows-6.jpg"
    };
    var requestedRenderIncarnation = 0;
    function renderPictures(previewAvailable, styleNumber, renderType) {
        var empty = $.Deferred();
        empty.resolve();
        var result = $.Deferred();
        if (!previewAvailable || styleNumber < 0) {
            return empty;
        }
        var attributeValues = formula.getAttributesFromForm(true);
        var renderHD = attributeValues.HDRenderingMode;
        var previewWidth = attributeValues.width;
        if (!previewWidth) {
            if (!(context_1["default"].goodProductPicturesAvailable)) {
                previewWidth = 100;
            }
            else if (!context_1["default"].isMobile()) {
                $("#desktopPreview").hide();
                $(".defaultPreview").hide();
                $(".defaultPicture").show();
                return empty;
            }
        }
        if (!previewWidth && context_1["default"].goodProductPicturesAvailable) {
            return empty;
        }
        var productType = number_1.firstNumber(renderType, attributeValues.productType * 1, getProductType() * 1, exports.ProductTypes.WindowOnly);
        if (number_1.extractFieldAsDecimal($('#customProgress')) === 0) {
            productType = ProductType.WindowOnly;
        }
        styleNumber = styleNumber || attributeValues.styleIndex;
        var origSpec = getFullSpec(styleNumber, productType);
        var isOriginalProduct = priceFormula_1.attributesMatchProductPicture();
        var _a = syncFullSpecWithAttributeValues(origSpec, productType, attributeValues), fullSpec = _a.fullSpec, canvasCount = _a.canvasCount, windowLeftMargin = _a.windowLeftMargin, windowRightMargin = _a.windowRightMargin;
        $(context_1["default"].isMobile() ? '.defaultPicture' : '.defaultPictureOrCanvas')
            .toggleClass('loading', true);
        requestedRenderIncarnation++;
        var renderIncarnationOfLoadedImages = requestedRenderIncarnation;
        loadImagesThenRenderPlus(fullSpec, renderHD ? hdPartsImageBase : partsImageBase, sceneImages, function (images) {
            if (!context_1["default"].isMobile()) {
                var $dp = $('#desktopPreview');
                if (!$dp.is(':visible') && !isOriginalProduct) {
                    $dp.css({ display: "flex", flexWrap: $dp.css('flexWrap') || 'wrap' });
                    $(".wallCanvas")[0].click();
                }
            }
            $(context_1["default"].isMobile() ? '.defaultPicture' : '.defaultPictureOrCanvas')
                .toggleClass('loading', false);
            if (context_1["default"].isMobile()) {
                var count = $(".wallCanvas.simulationCanvas").length;
                if (!isOriginalProduct && count != canvasCount) {
                    var parent_1 = $('.defaultPicture');
                    var paging = $('.paging');
                    if (canvasCount > count) {
                        var additionalCount_1 = canvasCount - count;
                        if (count > 0) {
                            parent_1.find('.wallCanvas.simulationCanvas').each(function (i, c) {
                                var $canvas = $(c);
                                $canvas.attr('zoomId', parseInt($canvas.attr('zoomId')) + additionalCount_1);
                            });
                        }
                        for (var i = additionalCount_1 - 1; i >= 0; i--) {
                            parent_1.prepend("<div class='canvasDiv'><canvas class='wallCanvas simulationCanvas' containingWidth='2160' containingHeight='2160' zoomId='" + i + "'/></div>");
                            paging.touchSlider('inc');
                        }
                        paging.touchSlider('current', 0);
                    }
                    else {
                        parent_1.find('.canvasDiv').filter(function (x) { return x >= canvasCount; }).remove();
                    }
                }
                else if (isOriginalProduct) {
                    $('.wallCanvas').parent().remove();
                    $(".paging span:nth-child(" + (count + 1) + ")").prevAll().remove();
                }
            }
            if (!isOriginalProduct) {
                renderZoomableCanvas($(".wallCanvas")[0], fullSpec, images, "0");
                if (productType !== ProductType.WindowOnly) {
                    var $animationIcon = $("#animationIcon");
                    var animationIconCanvas = $animationIcon.length > 0 ? $animationIcon[0] : null;
                    if (animationIconCanvas !== null) {
                        renderZoomableCanvas(animationIconCanvas, fullSpec, images, "0");
                        drawPlayButton(animationIconCanvas);
                    }
                    renderZoomableCanvas($(".wallCanvas")[1], fullSpec, images, "1");
                    renderZoomableCanvas($(".wallCanvas")[2], fullSpec, images, "2");
                    $(".wallCanvas.scene").each(function (index, elem) {
                        var canvas = elem;
                        renderZoomableCanvas(canvas, fullSpec, images, canvas.getAttribute("zoomId"));
                    });
                }
            }
            else {
                $('#desktopPreview').hide();
            }
            var currentCanvas = $(".defaultCanvas,.toggleToCanvases");
            var currentDefaultCanvasZoomId = $(currentCanvas[0]).attr("zoomId");
            if (!isOriginalProduct) {
                renderZoomableCanvas(currentCanvas[0], fullSpec, images, currentDefaultCanvasZoomId);
            }
            else {
                var preview = $('.defaultPreview');
                preview.hide();
                preview.next('.defaultPicture').show();
            }
            if (!context_1["default"].isMobile()) {
                var productPartialSequence;
                if ((fullSpec.style == 10) || (productType == ProductType.DrapeOnly)) {
                    productPartialSequence =
                        [[[["windowOnly", true]], ""],
                            [[["showDrapes", false], ["windowOnly", false]], "1. measure and install brackets to support a curtain rod"],
                            [[["showDrapes", true]], "2. hang the curtain panel on the rod"]];
                }
                else if (productType == ProductType.FullSet) {
                    productPartialSequence =
                        [[[["windowOnly", true]], ""],
                            [[["showValance", false], ["showDrapes", false], ["windowOnly", false], ["showDrapeRod", true]],
                                (fullSpec.style == 9) ? "1. measure and install bracket for curtain rod and holdbacks for the valance" : "1. measure and install brackets to support two curtain rods"],
                            [[["showDrapes", true]],
                                (fullSpec.style == 9) ? "2. hang the curtain panels on the rod" : "2. hang the curtain panels on the lower rod"],
                            [[["showValance", true], ["showDrapeRod", false]],
                                (fullSpec.style == 9) ? "3. hang the valance over the holdbacks" : "3. hang the valance on the upper rod"]];
                }
                else {
                    productPartialSequence =
                        [[[["windowOnly", true]], ""],
                            [[["showValance", false], ["windowOnly", false]],
                                (fullSpec.style == 9) ? "1. measure and install holdbacks for the valance" : "1. measure and install brackets to support a curtain rod"],
                            [[["showValance", true]],
                                (fullSpec.style == 9) ? "2. hange the valance over the holdbacks" : "2. hang the valance on the curtain rod"]];
                }
                installationRenderer = new InstallationRenderer(productPartialSequence, fullSpec, images, -(windowLeftMargin - fullSpec.setback + 3), fullSpec.setback + fullSpec.windowWidth + windowRightMargin + 3, -(fullSpec.windowHeight + fullSpec.windowTop2Ceiling + fullSpec.windowBottom2Floor - fullSpec.height) - 3, fullSpec.height + 6, ["#animationCanvas0", "#animationCanvas1"], "#animationTitle");
                var hdBounds = { width: 2400, height: 2400 };
                var containingWidth_1 = hdBounds.width, containingHeight_1 = hdBounds.height;
                if (requestedRenderIncarnation == renderIncarnationOfLoadedImages)
                    loadImagesThenRenderPlus(fullSpec, hdPartsImageBase, sceneImages, function (hdImages) {
                        var canvas = $("<canvas containingWidth=\"" + containingWidth_1 + "\" containingHeight=\"" + containingHeight_1 + "\" minHeight=\"800\"></canvas>")[0];
                        renderZoomableCanvas(canvas, fullSpec, hdImages, $(currentCanvas[0]).attr("zoomId"));
                        $("#zoomableCanvas").parent().attr("href", canvas.toDataURL('image/jpeg', 0.8))
                            .attr('data-gallery', 'lightbox-pd');
                        $("#zoomableCanvas").parent().CloudZoom();
                        $("a[data-gallery^='lightbox']").unbind('click');
                        productImages_1.slimBoxClicker().slimbox({
                            links: productImages_1.buildSlimboxLinks(),
                            loop: true,
                            nextKeys: [39, 78, 32]
                        }, function (link, i) {
                            var $link = $(link);
                            var href = $link.attr('href');
                            if (href.indexOf('#desktopPreview/zoomId/') === 0) {
                                var zoomId = $(link).attr('zoomId');
                                var canvas_2 = $("<canvas containingWidth=\"" + containingWidth_1 + "\" containingHeight=\"" + containingHeight_1 + "\" minHeight=\"800\"></canvas>")[0];
                                canvas_2 = renderZoomableCanvas(canvas_2, fullSpec, hdImages, zoomId);
                                return [canvas_2.toDataURL('image/jpeg', 0.8), $link.attr('title')];
                            }
                            else {
                                return [href, $link.attr('title')];
                            }
                        });
                    });
            }
            else {
                renderLiveViewCurtain(fullSpec, images);
                assetPicker_1.ensureMobilePictureShown();
                var $photos = $('.photoshow .defaultPicture');
                var $cur = $photos.find('.current');
                if ($cur.length === 0) {
                    $photos.touchSlider('current', 0);
                }
                else {
                    var useCur = $cur.index() === 0 || $cur.hasClass('canvasDiv');
                    if (!useCur) {
                        var $prev = $cur.prev('.canvasDiv');
                        var $prevCanvas = $prev.length ? $prev : $cur.prevUntil('.canvasDiv').prev();
                        $photos.touchSlider('current', $prevCanvas.index());
                    }
                }
                if (!isOriginalProduct && requestedRenderIncarnation == renderIncarnationOfLoadedImages) {
                    loadImagesThenRender(fullSpec, hdPartsImageBase, function (hdImages) {
                        renderZoomableCanvas($(".wallCanvas")[0], fullSpec, hdImages, "0");
                        if (productType !== ProductType.WindowOnly) {
                            drawCurtainSet($(".wallCanvas")[1], fullSpec, { x0: 0 + 5, x1: fullSpec.width - 5, y0: 5, y1: Math.min(5 + (fullSpec.width - 10), fullSpec.height - 5), expansionMode: "down", maxHeight: fullSpec.height - 10 }, hdImages, !noWall);
                            drawCurtainSet($(".wallCanvas")[2], fullSpec, { x0: 0, x1: Math.min(60, fullSpec.width / 2), y0: 0, y1: 60, expansionMode: "right", maxWidth: Math.min(60, fullSpec.width * 0.7) }, hdImages, !noWall);
                        }
                    });
                }
            }
            result.resolve();
        });
        return result;
    }
    exports.renderPictures = renderPictures;
    function placeCurtainOnCanvas(canvas, renderedCurtainCanvas, x0, y0, x1, y1, x2, y2, x3, y3) {
        var ctx = canvas.getContext("2d");
        placeCurtainOnCanvasUsingContext(ctx, renderedCurtainCanvas, x0, y0, x1, y1, x2, y2, x3, y3);
    }
    function placeCurtainOnCanvasUsingContext(ctx, renderedCurtainCanvas, x0, y0, x1, y1, x2, y2, x3, y3) {
        if (canvasPerspectiveTransform) {
            ctx.save();
            var transformed = canvasPerspectiveTransform(renderedCurtainCanvas, x0, y0, x1, y1, x2, y2, x3, y3);
            ctx.beginPath();
            ctx.moveTo(x0, y0);
            ctx.lineTo(x1, y1);
            ctx.lineTo(x3, y3);
            ctx.lineTo(x2, y2);
            ctx.closePath();
            ctx.clip();
            if (transformed[4]) {
                ctx.drawImage(transformed[4], transformed[0], transformed[1], transformed[2] - transformed[0], transformed[3] - transformed[1]);
            }
            ctx.restore();
        }
    }
    function placeCurtainOnDesignSketch(box, simpleSpec, drawWall, drawWindow) {
        var coords = [];
        for (var _i = 4; _i < arguments.length; _i++) {
            coords[_i - 4] = arguments[_i];
        }
        var result = $.Deferred();
        var canvas = document.createElement('canvas');
        var renderBox = design_1.fitBoundingBox(box, { Width: 960, Height: 960 });
        var scale = renderBox.Width / box.Width;
        var reverseScale = 1.0 / scale;
        canvas.setAttribute('width', "" + renderBox.Width);
        canvas.setAttribute('height', "" + renderBox.Height);
        if (scale !== 1.0) {
            canvas.setAttribute('style', "transform: scale(" + reverseScale + ");transform-origin: 0 0;");
        }
        var fullSpec = complete_custom_parameters(simpleSpec);
        loadAndRenderFullSpec(fullSpec, drawWall, drawWindow)
            .then(function (curtain) {
            placeCurtainOnCanvas.apply(null, [canvas, curtain].concat((coords.map(function (x) { return x * scale; }))));
            result.resolve(canvas);
        });
        return result.promise();
    }
    exports.placeCurtainOnDesignSketch = placeCurtainOnDesignSketch;
    function renderZoomableCanvas(canvas, fullSpec, images, zoomId, noWall, leftMargin, rightMargin, topMargin, bottomMargin) {
        if (noWall === void 0) { noWall = false; }
        if (leftMargin === void 0) { leftMargin = -1; }
        if (rightMargin === void 0) { rightMargin = -1; }
        if (topMargin === void 0) { topMargin = -1; }
        if (bottomMargin === void 0) { bottomMargin = -1; }
        analytics_1["default"]('renderCustom', 'started', zoomId);
        var windowLeftMargin = fullSpec.windowLeftMargin;
        var windowRightMargin = fullSpec.windowRightMargin;
        switch (zoomId) {
            case "0":
                if (fullSpec.windowType == WindowType.BayWindow) {
                    var sideWindowWidth = fullSpec.sideCurtainWidth - 2 * fullSpec.setback;
                    var sideWallExtraMargin = 3;
                    var sideWallWidth = sideWindowWidth + windowLeftMargin + windowRightMargin + sideWallExtraMargin;
                    var xRatio = 0.75;
                    var yRatio = 0.3;
                    var sideWallWidthProjected = sideWallWidth * xRatio;
                    var sideWallTopProjected = sideWallWidth * yRatio;
                    var centerWallLeftX = -(windowLeftMargin - fullSpec.setback);
                    var centerWallRightX = fullSpec.setback + fullSpec.windowWidth + windowRightMargin;
                    var centerWallTopY = -(fullSpec.windowHeight + fullSpec.windowTop2Ceiling + fullSpec.windowBottom2Floor - fullSpec.height);
                    var sideWallTopY = centerWallTopY - sideWallTopProjected;
                    var centerWallBottomY = fullSpec.height;
                    var sideWallBottomY = centerWallBottomY + sideWallTopProjected;
                    var sideWallLeftX = centerWallLeftX - sideWallWidthProjected;
                    var sideWallRightX = centerWallRightX + sideWallWidthProjected;
                    var curtainBottomY = centerWallBottomY + 3;
                    var ctx = drawCurtainSet(canvas, __assign({}, fullSpec, { drapes: DrapeConfig.leftAndRight, rightDrapeFaded: false }), { x0: sideWallLeftX - ((leftMargin == -1) ? 20 : leftMargin),
                        x1: sideWallRightX + ((rightMargin == -1) ? 20 : rightMargin),
                        y0: sideWallTopY - ((topMargin == -1) ? 6 : topMargin),
                        y1: sideWallBottomY + ((bottomMargin == -1) ? 8 : bottomMargin) }, images, !noWall, !noWall, false);
                    var wallColorHex = fullSpec.wallColorHex || exports.wallColor_to_hex[fullSpec.wallColor] || "#a9a9a9";
                    if (!noWall) {
                        drawQuadrilateral(ctx, sideWallLeftX - 20, sideWallTopY, sideWallLeftX, sideWallTopY, sideWallLeftX, sideWallBottomY, sideWallLeftX - 20, sideWallBottomY, wallColorHex);
                        drawQuadrilateral(ctx, sideWallRightX + 20, sideWallTopY, sideWallRightX, sideWallTopY, sideWallRightX, sideWallBottomY, sideWallRightX + 20, sideWallBottomY, wallColorHex);
                        drawQuadrilateral(ctx, sideWallLeftX - 20, sideWallTopY - 6, sideWallRightX + 20, sideWallTopY - 6, sideWallRightX + 20, sideWallTopY, sideWallLeftX - 20, sideWallTopY, lighten(wallColorHex, 0.15));
                        drawQuadrilateral(ctx, sideWallLeftX, sideWallTopY, sideWallRightX, sideWallTopY, centerWallRightX, centerWallTopY, sideWallLeftX, centerWallTopY, lighten(wallColorHex, 0.15));
                        drawQuadrilateral(ctx, sideWallLeftX, sideWallBottomY, centerWallLeftX, sideWallBottomY, centerWallLeftX, centerWallBottomY, centerWallLeftX, centerWallBottomY, lighten(wallColorHex, -0.15));
                        drawQuadrilateral(ctx, sideWallRightX, sideWallBottomY, centerWallRightX, sideWallBottomY, centerWallRightX, centerWallBottomY, centerWallRightX, centerWallBottomY, lighten(wallColorHex, -0.15));
                        drawQuadrilateral(ctx, sideWallLeftX - 20, sideWallBottomY + 8, sideWallRightX + 20, sideWallBottomY + 8, sideWallRightX + 20, sideWallBottomY - 0.05, sideWallLeftX - 20, sideWallBottomY - 0.05, lighten(wallColorHex, -0.15));
                        drawQuadrilateral(ctx, sideWallLeftX, sideWallTopY, centerWallLeftX, centerWallTopY, centerWallLeftX, centerWallBottomY, sideWallLeftX, sideWallBottomY, lighten(wallColorHex, 0.1));
                        drawQuadrilateral(ctx, sideWallRightX, sideWallTopY, centerWallRightX, centerWallTopY, centerWallRightX, centerWallBottomY, sideWallRightX, sideWallBottomY, lighten(wallColorHex, 0.1));
                    }
                    var sideCurtainCanvas = document.createElement('canvas');
                    $(sideCurtainCanvas).attr("containingHeight", 3000);
                    $(sideCurtainCanvas).attr("containingWidth", 3000);
                    var fullSpecSide = __assign({}, fullSpec);
                    fullSpecSide.wallColorHex = lighten(wallColorHex, 0.1);
                    fullSpecSide.width = fullSpec.sideCurtainWidth;
                    fullSpecSide.drapeWidth = fullSpecSide.Width;
                    fullSpecSide = complete_custom_parameters(fullSpecSide);
                    var sideWindowWith2Panels = fullSpecSide.style === StyleEnum.PanelWithSwag ? fullSpecSide.width >= 70 : fullSpecSide.width > 45;
                    fullSpecSide.drapes = sideWindowWith2Panels ? DrapeConfig.leftAndRight : DrapeConfig.leftOnly_Wide;
                    fullSpecSide.windowLeftMargin = windowLeftMargin + sideWallExtraMargin;
                    fullSpecSide.setback = fullSpec.setback;
                    fullSpecSide.windowRightMargin = windowRightMargin;
                    fullSpecSide.windowWidth = sideWindowWidth;
                    drawCurtainSet(sideCurtainCanvas, fullSpecSide, { x0: -(fullSpecSide.windowLeftMargin - fullSpecSide.setback), x1: fullSpecSide.setback + sideWindowWidth + windowRightMargin, y0: centerWallTopY, y1: curtainBottomY }, images, false, !noWall);
                    placeCurtainOnCanvasUsingContext(ctx, sideCurtainCanvas, centerWallLeftX - sideWallWidthProjected, centerWallTopY - sideWallTopProjected, centerWallLeftX, centerWallTopY, centerWallLeftX - sideWallWidthProjected, curtainBottomY + sideWallTopProjected, centerWallLeftX, curtainBottomY);
                    placeCurtainOnCanvasUsingContext(ctx, sideCurtainCanvas, centerWallRightX + sideWallWidthProjected, centerWallTopY - sideWallTopProjected, centerWallRightX, centerWallTopY, centerWallRightX + sideWallWidthProjected, curtainBottomY + sideWallTopProjected, centerWallRightX, curtainBottomY);
                    break;
                }
                drawCurtainSet(canvas, fullSpec, {
                    x0: (leftMargin == -1) ? -(windowLeftMargin - fullSpec.setback + 10) : -leftMargin,
                    x1: (rightMargin == -1) ? (fullSpec.setback + fullSpec.windowWidth + windowRightMargin + 10) : (rightMargin + fullSpec.width),
                    y0: (topMargin == -1) ? -(fullSpec.windowHeight + fullSpec.windowTop2Ceiling + fullSpec.windowBottom2Floor - fullSpec.height) - 6 : -topMargin,
                    y1: (bottomMargin == -1) ? fullSpec.height + 8 : (fullSpec.height + bottomMargin)
                }, images, !noWall, !noWall);
                break;
            case "1":
                drawCurtainSet(canvas, fullSpec, { x0: 0 + 5, x1: fullSpec.width - 5, y0: 5, y1: Math.min(5 + (fullSpec.width - 10), fullSpec.height - 5), expansionMode: "down", maxHeight: fullSpec.height - 10 }, images, !noWall, !noWall);
                break;
            case "2":
                drawCurtainSet(canvas, fullSpec, { x0: 0, x1: Math.min(60, fullSpec.width / 2), y0: 0, y1: 60, expansionMode: "right", maxWidth: Math.min(60, fullSpec.width * 0.7) }, images, !noWall, !noWall);
                break;
            default:
                if (!zoomId || !zoomId.startsWith("10-"))
                    break;
                if (zoomId == "10-customScene") {
                    var $customerSceneBackground = $("#customerSceneBackground");
                    var _a = $customerSceneBackground.data('layout'), videoBox = _a.videoBox, liveCurtainBox = _a.liveCurtainBox, offset = _a.offset;
                    var imageOrCanvas = $customerSceneBackground[0];
                    var iocWidth = imageOrCanvas.width;
                    var iocHeight = imageOrCanvas.height;
                    var scaleX = iocWidth / videoBox.width;
                    var scaleY = iocHeight / videoBox.height;
                    var curtains = [{
                            fullSpec: fullSpec,
                            canvasX0: scaleX * (offset.left + liveCurtainBox.left),
                            canvasX1: scaleX * (offset.left + liveCurtainBox.left + liveCurtainBox.width),
                            canvasY0: scaleY * (offset.top + liveCurtainBox.top),
                            canvasY1: scaleY * (offset.top + liveCurtainBox.top + liveCurtainBox.width * (1.0 * fullSpec.height / fullSpec.width))
                        }];
                    renderCurtainWithBackgroundImage(canvas, imageOrCanvas, images, curtains, true);
                    break;
                }
                var sceneSetting = roomSettings[zoomId.substring(3)];
                var curtains = [];
                sceneSetting.curtainPositions.forEach(function (pos) {
                    var curtainSimpleSpec = {
                        width: pos.width,
                        height: pos.height,
                        productType: fullSpec.productType == ProductType.DrapeOnly ? ProductType.DrapeOnly : (sceneSetting.productType == null ? fullSpec.productType : sceneSetting.productType),
                        style: fullSpec.style,
                        withSheers: fullSpec.withSheers,
                        fabricMain: fullSpec.fabricMain,
                        fringeStyle: fullSpec.fringeStyle,
                        windowWidth: fullSpec.windowWidth
                    };
                    var curtainFullSpec = complete_custom_parameters(curtainSimpleSpec);
                    curtains.push({ fullSpec: curtainFullSpec, canvasX0: pos.x0, canvasX1: pos.x1, canvasY0: pos.y0, canvasY1: pos.y1 });
                });
                renderCurtainWithBackgroundImage(canvas, images["img_" + zoomId.substr(3)], images, curtains);
        }
        analytics_1["default"]('renderCustom', 'ended', zoomId);
        return canvas;
    }
    function renderCanvas(canvasElement, fabricCodeName, fabricId, productType, attributeValues) {
        var result = $.Deferred();
        var canvasStyleIndex = getStyleIndexFromStyleName($(canvasElement).attr("styleName"));
        if (canvasStyleIndex == -1) {
            $(canvasElement).parent().parent().parent().parent().parent().hide();
            result.resolve();
            return result;
        }
        var simpleSpec = {
            width: (attributeValues != null && attributeValues.width != null && canvasStyleIndex != 10) ? attributeValues.width : 70,
            height: (attributeValues != null) ? attributeValues.height : 96,
            style: canvasStyleIndex,
            productType: productType,
            withSheers: false,
            fabricMain: getFabricNameFromCodeName(fabricCodeName),
            fringeStyle: (attributeValues != null) ? attributeValues.fringeColor : 3
        };
        if (simpleSpec.width < 50 && ((canvasStyleIndex == 6) || (canvasStyleIndex == 8))) {
            simpleSpec.width = 50;
        }
        var fullSpec = complete_custom_parameters(simpleSpec);
        loadImagesThenRender(fullSpec, partsImageBase, function (images) {
            drawCurtainSet(canvasElement, fullSpec, { x0: -6, x1: fullSpec.width + 6, y0: -6, y1: fullSpec.height + 6, expansionMode: "down" }, images);
            result.resolve();
        });
        $(canvasElement).parent().show();
        $(canvasElement).parent().parent().find(".placeholder").hide();
        if (fabricId != null) {
            var targetUrl = $(canvasElement).parent().parent().parent().attr("href");
            if (targetUrl.indexOf("customize?") == -1) {
                var queryParameters = "?fabricId=" + fabricId;
                if (attributeValues != null && attributeValues.width != null && canvasStyleIndex != 10)
                    queryParameters += "&width=" + attributeValues.width;
                if (attributeValues != null && attributeValues.height != null)
                    queryParameters += "&height=" + attributeValues.height;
                if (attributeValues != null && attributeValues.fringeColor != null)
                    queryParameters += "&fringeColor=" + attributeValues.fringeColor;
                $(canvasElement).parent().parent().parent().attr("href", targetUrl.replace(/[?].*$/g, queryParameters));
            }
        }
        return result;
    }
    exports.renderCanvas = renderCanvas;
    function renderOverlayCanvas(canvasElement, fabricCodeName, styleIndex, productType, attributeValues, canvasX0, canvasX1, canvasY0, canvasY1, noClear) {
        var result = $.Deferred();
        var withSheers = attributeValues.sheerGrade && parseInt(attributeValues.sheerGrade) > 0;
        var simpleSpec = {
            width: (attributeValues != null && attributeValues.width != null && styleIndex != 10) ? attributeValues.width : 90,
            height: (attributeValues != null) ? attributeValues.height : 96,
            style: styleIndex,
            productType: productType,
            withSheers: withSheers,
            fabricMain: fabricCodeName,
            fringeStyle: (attributeValues != null) ? attributeValues.fringeColor : 3
        };
        var fullSpec = complete_custom_parameters(simpleSpec);
        loadImagesThenRender(fullSpec, partsImageBase, function (images) {
            drawCurtainSet(canvasElement, fullSpec, { x0: -1.5, x1: fullSpec.width + 1.5, y0: -1, y1: fullSpec.height + 4, canvasX0: canvasX0, canvasX1: canvasX1, canvasY0: canvasY0, canvasY1: canvasY1 }, images, false, false, noClear);
            result.resolve();
        });
        return result;
    }
    exports.renderOverlayCanvas = renderOverlayCanvas;
    function renderCurtainWithBackgroundImage(canvas, backgroundImage, images, curtains, liveViewBackground) {
        if (liveViewBackground === void 0) { liveViewBackground = false; }
        var imageWidth = backgroundImage.width;
        var imageHeight = backgroundImage.height;
        var canvasWidth = imageWidth, canvasHeight = imageHeight;
        if (canvas.hasAttribute("containingWidth") && canvas.hasAttribute("containingHeight")) {
            var containingWidth = parseFloat(canvas.getAttribute("containingWidth"));
            var containingHeight = parseFloat(canvas.getAttribute("containingHeight"));
            var scale = Math.min(containingWidth / imageWidth, containingHeight / imageHeight);
            var canvasWidth, canvasHeight;
            canvasHeight = scale * imageHeight;
            canvasWidth = scale * imageWidth;
        }
        $(canvas).attr("height", canvasHeight);
        $(canvas).attr("width", canvasWidth);
        var ctx = canvas.getContext("2d");
        ctx.drawImage(backgroundImage, 0, 0, canvasWidth, canvasHeight);
        curtains.forEach(function (curtain) {
            if (!liveViewBackground) {
                drawCurtainSet(canvas, curtain.fullSpec, {
                    x0: -1.5,
                    x1: curtain.fullSpec.width + 1.5,
                    y0: -1,
                    y1: curtain.fullSpec.height + 4,
                    canvasX0: curtain.canvasX0 * scale,
                    canvasX1: curtain.canvasX1 * scale,
                    canvasY0: curtain.canvasY0 * scale,
                    canvasY1: curtain.canvasY1 * scale
                }, images, false, false, true);
            }
            else {
                var liveViewCanvas = document.createElement("canvas");
                renderFullSpecToCanvas({ Width: 3000, Height: 3000 }, liveViewCanvas, curtain.fullSpec, images);
                ctx.drawImage(liveViewCanvas, curtain.canvasX0 * scale, curtain.canvasY0 * scale, (curtain.canvasX1 - curtain.canvasX0) * scale, (curtain.canvasY1 - curtain.canvasY0) * scale);
            }
        });
    }
    function renderFullSpecToCanvas(maxSize, canvas, fullSpec, images) {
        var maxWidth = maxSize.Width, maxHeight = maxSize.Height;
        var scale = Math.min(maxWidth / (fullSpec.width + 3), maxHeight / (fullSpec.height + 5));
        var curtainWidthOnCanvas = scale * (fullSpec.width + 3);
        var curtainHeightOnCanvas = scale * (fullSpec.height + 5);
        $(canvas).attr('width', curtainWidthOnCanvas);
        $(canvas).attr('height', curtainHeightOnCanvas);
        $(canvas).attr("virtualWidth", fullSpec.width + 3.0);
        $(canvas).attr("virtualHeight", fullSpec.height + 5.0);
        $(canvas).attr("virtualTop", -1);
        $(canvas).attr("virtualMiddle", fullSpec.width / 2);
        var canvasX0 = 0;
        var canvasY0 = 0;
        renderZoomableCanvas(canvas, fullSpec, images, "0", true, 1.5, 1.5, 1, 4);
    }
    ;
    var _renderFullSpecToId = function (canvasId) { return function (fullSpec) { return function (images) {
        var $curtainCanvas = $(canvasId);
        var $window = $(window);
        var maxSize = { Width: $window.width() * .72, Height: $window.height() * .72 };
        if ($curtainCanvas.length) {
            var canvas = $curtainCanvas[0];
            renderFullSpecToCanvas(maxSize, canvas, fullSpec, images);
        }
    }; }; };
    var renderFullSpecToId = util_1.uncurry(_renderFullSpecToId);
    var renderLiveViewCurtain = function (fullSpec, images) { return renderFullSpecToId('#liveViewCurtain', fullSpec, images); };
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/renderCustomValance.js
// module id = 44
// module chunks = 0